import store from "../../store/index";
import pointCtx from "@/assets/font/woff/ctx"; //绘制点方法
import comTool from "@/assets/js/customModules/tools";
import axios from "axios";
import md5 from 'js-md5'
import html2canvas from "html2canvas";
import {
  getVetorLayerNode,
  getPageType,
  getPolygonStyle,
  getPolylineStyle,
  getPointStyle,
  stopDrawText,
  startDrawText,
  getColor,
  setCanvasPicked,
  redrawSelectedCanvas,
  startDraw,
  getChangedData,
  getCoordByRowCol,
  getRowCol,
  createPointCanvas,
  getCacheColor,
  clearArcLineArr,
  isAddToParams,
  convertMapExtent,
  drawChangedData,
  getSingleRowCol,
  clearSelectCanvasByType,
  resetSelectCanvasByEdit,
  createCanvas,
  reorderPickedLayer,
  loadCompleted,
  getAttrStyle,
  clearSelectCanvas,
  loadDragData,
  getLegend,
  sortLayerIndex,
  createGSPTile,
  getGeometry,
  drawData_Changed,
  updateAllChangedData,
  updateChangedData,
  getGeometryToScreen,
  drawOnCanvas,
  convertLngLat,
  isShowLayer,
  MergeArray
} from "@/assets/js/common.js";
import DTPLabel from "@/assets/js/dtpLabel.js";
import {
  UploadImage
} from "@/assets/api/home-api";
import {
  getGDataObject
} from "@/assets/api/detaildata";
import request from "@/assets/api/newApi";
import {
  addLayer
} from "@/assets/api/layer";
import {
  resolve
} from "tinymce";

//label值id
window.LabelIds = {};

//label值
window.LabelVals = {};

//唯一值、分级渲染值id
window.ZrenUniderIds = {};

//唯一值,分级渲染值
window.ZrenUniderVals = {};

window.changedCacheContexts = [];

window.screenCacheContexts = [];

//置顶数据
window.onTopData = {};

//放置类型，置顶、置底
window.placeType = {};

//记录已删除的行列id
window.deleteColRowIds = [];

//记录添加的行列id
window.addColRowIds = [];

//保存选择 勾选关闭的数据
window.selectQueryData = [];

//未绘制的底图切片
window.ZHT_noDrawBaseData = [];

//上一次的extent
window.ZHT_lastExtent = ""

//但前的extent
window.ZHT_curtentExtent = ""

//上一次坐标轴 切片
window.ZHT_SecLastCoordinate = []

//上一次坐标轴 缓存
window.ZHT_CacheLastCoordinate = []

// 上一次坐标轴 数据库数据
window.ZHT_CacheChangedLastLineCoordinate = [];

//记录小于50距离的上一个坐标
window.ZHT_recLineLastCoordinate = [];

//小于50距离的和
window.ZHT_recLineSpaceCount = 0;

//导出图片extent中最小的点
window.ZHT_ExportImgMinExtent = []

//导出图片最小行列的偏移量
window.ZHT_ExportImgMinRCOffset = []

//导出图片切片循环总数
window.ZHT_ExportImgTotal = 0;

//导出图片切片循环次数
window.ZHT_ExportImgCount = 0;

//导出图片图片下载次数
window.ZHT_ExportImgDownLoadCount = 0;

var repearData = []

export default {
  /**
   * 全部图层是否关闭
   */
  isAllLayerClose() {
    var closeArr = [];
    var layerNodes = getVetorLayerNode(store.state.dataTreeData);
    store.state.allLayerData.forEach(layer => {
      var index = layerNodes.findIndex(node => node.id === layer.Id);
      if (index > -1) {
        if (!layerNodes[index].checked || !layerNodes[index].isShowLayer) {
          closeArr.push(layer);
        }
      }
    });
    return closeArr.length === store.state.allLayerData.length;
  },
  /**
   * 查询当前图层是否可选择
   * @param {*} layerId
   */
  isLayerSelect(layerId) {
    var index = store.state.allLayerData.findIndex(
      layer => layer.Id === layerId
    );
    if (index === -1) {
      return true;
    }
    var layerNodes = getVetorLayerNode(store.state.dataTreeData);
    var layerIndex = layerNodes.findIndex(node => node.id === layerId);
    var curNode = layerNodes[layerIndex];
    if (curNode && curNode.isShowLayer) {
      return store.state.allLayerData[index].IsChoice && curNode.isShowLayer;
    } else {
      return store.state.allLayerData[index].IsChoice;
    }
  },
  /**
   * 简单渲染缓存
   * tagname 字段值
   * getDataType 1渲染 2带坐标 标注
   */
  getRenderLabelVals(layerId, data, tagname, type, getDataType) {
    // FIXME console.log("layerId",layerId, "data",data,"tagname", tagname,"type", type,"getDataType", getDataType)
    startDrawText();
    return new Promise(async (resolve, reject) => {
      var layerNodes = getVetorLayerNode(store.state.dataTreeData);
      var layerIndex = layerNodes.findIndex(node => node.id === layerId);
      var curNode = layerNodes[layerIndex];
      var setUpData = [];
      // 判断data是否为空
      if (data.length !== 0) {
        localStorage.setItem('renderData', JSON.stringify(data))
      } else {
        data = JSON.parse(localStorage.getItem('renderData'))
      }
      // console.log("layerId->",layerId, "data->",data,"tagname->", tagname,"type->", type,"getDataType->", getDataType)


      if (type === "Attribute") {
        for (let index = 0; index < data.length; index++) {
          var res = data[index];
          setUpData.push(res.Attr.ID);
        }
      } else {
        for (let index = 0; index < data.length; index++) {
          var res = data[index];
          setUpData.push(res.O);
        }
      }
      let dataType = !getDataType ? 1 : getDataType;
      let pagetype = getPageType();
      var val = {
        UserId: store.state.user.userid,
        GDataId: curNode.gDataId,
        mapDocId: pagetype == 1 ? store.state.SingleData.MapDocs.ID : -1,
        tagname: tagname,
        type: pagetype == 1 ? 1 : 0,
        allid: setUpData,
        getDataType: dataType
      };

      //没有的数据
      var arr = [];
      //已经存在的数据
      var existArr = [];
      var renderIdList = LabelIds[layerId] ? LabelIds[layerId] : [],
        allIds = val.allid;
      var renderVal = LabelVals[layerId] ? LabelVals[layerId] : [];
      for (var i = allIds.length - 1; i >= 0; i--) {
        const item = allIds[i];
        let idIndex = -1;
        if (renderIdList.length) {
          idIndex = renderIdList.findIndex(
            rid => rid === item && renderVal[item] != undefined
          );
          idIndex === -1 ? arr.push(item) : existArr.push(item);
        } else {
          arr.push(item);
        }
      }
      if (arr.length) {
        val.allid = arr;
        if (!val.tagname) {
          resolve(LabelVals[layerId] ? LabelVals[layerId] : {});
          return "123";
        }
        // 写入数据
        for (let i = 0; i < arr.length; i++) {
          renderIdList.push(arr[i]);
        }
        LabelIds[layerId] = [...new Set(renderIdList)];
        request.GetFiledValueByIDs(val).then(res => {
          if (res.status === 200) {
            let renderDicVals = {};
            let _LabelVals = LabelVals[layerId];
            renderDicVals[layerId] = _LabelVals ? _LabelVals : {};
            renderDicVals[layerId] = Object.assign(
              renderDicVals[layerId],
              res.data
            );
            LabelVals[layerId] = renderDicVals[layerId];
            resolve(LabelVals[layerId]);
          }
        });
      } else {
        var dic = {};
        for (let index = 0; index < existArr.length; index++) {
          const pelement = existArr[index];
          dic[pelement] = LabelVals[layerId][pelement];
        }
        stopDrawText();
        resolve(dic);
      }
    });
  },

  /**
   *  唯一值/分级渲染数据缓存
   * @param {*} layerId 图层Id
   * @param {*} data 切片数据
   * @param {*} tagname 值字段
   * @param {*} type vector 矢量数据  Attribute 数据库数据
   * @param {*} getDataType 请求数据时候参数：1渲染 2带坐标
   * @returns
   */
  getUniRenderLabelVals(layerId, data, tagname, type, getDataType) {
    // console.log(layerId,getDataType,'变化数据')
    startDrawText();
    var layerNodes = getVetorLayerNode(store.state.dataTreeData);
    var layerIndex = layerNodes.findIndex(node => node.id === layerId);
    var curNode = layerNodes[layerIndex];
    var setUpData = [];
    // var repeatIndex = AllChangedData.findIndex(val => val.layerId == layerId)

    // console.log(layerId,getDataType,'变化数据')
    // if(repeatIndex > -1){
    //   if(data[0].Attr && data[0].Shape){
    //     for(var m=0;m<data.length;m++){
    //       for(var n=0;n<AllChangedData[repeatIndex].data.length;n++){
    //         if(data[m].Attr.ID == AllChangedData[repeatIndex].data[n].Attr.ID &&(data[m].Shape[0][0][0] != AllChangedData[repeatIndex].data[n].Shape[0][0][0] || data[m].Shape[0][0][1] != AllChangedData[repeatIndex].data[n].Shape[0][0][1] )){
    //           continue
    //         }
    //       }
    //     }
    //   }
    // }
    if (type === "Attribute") {
      for (let index = 0; index < data.length; index++) {
        var res = data[index];
        if (res.Attr) {
          setUpData.push(res.Attr.ID);
          repearData.push({
            layerId: layerId,
            ID: res.Attr.ID
          })
        }
      }
    } else {
      // console.log(data)
      for (let index = 0; index < data.length; index++) {
        var res = data[index];
        var repeatIndex = repearData.findIndex(val => val.ID == res.O && val.layerId == layerId)
        if (repeatIndex > -1) {
          continue
        } else {
          setUpData.push(res.O);
        }

      }
      // console.log(setUpData,'变化数据2')
    }
    // 1渲染 2带坐标
    var dataType = !getDataType ? 1 : getDataType;
    return new Promise(async (resolve, reject) => {
      let pagetype = getPageType();
      if (curNode) {
        var val = {
          UserId: store.state.user.userid,
          GDataId: curNode.gDataId,
          mapDocId: pagetype == 1 ? store.state.SingleData.MapDocs.ID : -1,
          tagname: tagname,
          type: pagetype == 1 ? 1 : 0,
          allid: setUpData,
          getDataType: dataType
        };
        var arr = [];
        var existArr = [];
        // 取出该图层的渲染数据
        var renderIdList = ZrenUniderIds[layerId] ? ZrenUniderIds[layerId] : [];
        var renderVal = ZrenUniderVals[layerId] ? ZrenUniderVals[layerId] : [];
        var allIds = val.allid;
        for (let index = 0; index < allIds.length; index++) {
          if (store.state.stopLoading) return;
          var item = allIds[index];
          var idIndex = -1;
          if (renderIdList.length) {
            // && renderVal[item]
            idIndex = renderIdList.findIndex(
              rid => rid === item && renderVal[item] != undefined
            );
            idIndex === -1 ? arr.push(item) : existArr.push(item);
          } else {
            arr.push(item);
          }
        }

        if (arr.length > 0) {
          val.allid = arr;
          if (!val.tagname) {
            resolve(ZrenUniderVals[layerId] ? ZrenUniderVals[layerId] : {});
            return;
          }
          // console.log("GetFiledValueByIDs---", val.allid, renderIdList)
          for (let i = 0; i < arr.length; i++) {
            const a = arr[i];
            renderIdList.push(a);
          }
          // 唯一值id写入数据
          ZrenUniderIds[layerId] = [...new Set(renderIdList)];
          request.GetFiledValueByIDs(val).then(res => {
            if (res.status === 200) {
              // 写入数据
              let _zrenUniderVals = ZrenUniderVals[layerId];
              let renderDicVals = {};
              renderDicVals[layerId] = _zrenUniderVals ? _zrenUniderVals : {};
              renderDicVals[layerId] = Object.assign(renderDicVals[layerId], res.data);
              ZrenUniderVals[layerId] = renderDicVals[layerId];
              resolve(ZrenUniderVals[layerId]);
            }
            stopDrawText();
          });
        } else {
          var dic = {};
          for (let index = 0; index < existArr.length; index++) {
            var pelement = existArr[index];
            dic[pelement] = ZrenUniderVals[layerId][pelement];
          }
          // var dic = this.getZrenUniderVals(existArr, layerId)
          // 查询所有的值
          // dic = ZrenUniderVals[layerId]
          stopDrawText();
          resolve(dic);
        }
      }
    });
  },
  // 递归查询出有id值的数据
  getZrenUniderVals(existArr, layerId) {
    var dic = {};
    for (let index = 0; index < existArr.length; index++) {
      var pelement = existArr[index];
      //
      if (pelement) {
        if (!ZrenUniderVals[layerId] || !ZrenUniderVals[layerId][pelement]) {
          this.getZrenUniderVals(existArr, layerId)
        } else {
          dic[pelement] = ZrenUniderVals[layerId][pelement];
        }
      }
    }
    return dic
  },

  /**清除该图层所有的渲染缓存值 */
  clearUniderVals(layerId) {
    ZrenUniderIds[layerId] = [];
    ZrenUniderVals[layerId] = {};
  },
  /**重置多个符号渲染 */
  resetMultiSymbolRender(layerId, attrs) {
    return new Promise(async (resolve, reject) => {
      clearSelectCanvas("selected");
      var nwTileData = TileData.filter(ele => ele.layerId == layerId);
      var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
      let layerSym = JSON.parse(layerInfo.Symbol);
      var renderVals = ZrenUniderVals[layerId];
      var data;
      attrs.forEach(attr => {
        renderVals[attr.ID] = attr[layerSym.FieldName];
        for (var i = 0; i < nwTileData.length; i++) {
          if (nwTileData[i].data.J) {
            let index = nwTileData[i].data.J.findIndex(
              ele => ele.O == attr.ID
            );
            if (index > -1) {
              data = nwTileData[i];
            }
          }
          if (data) {
            //移除选中的canvas
            var canvasCtn = document.getElementsByClassName("gispaiLayer");
            if (canvasCtn && canvasCtn.length > 0) {
              for (var j = 0; j < canvasCtn.length; j++) {
                if (canvasCtn[i].attributes.targetType.value == "data") {
                  var ids = canvasCtn[j].id.split("_");
                  if (canvasCtn[j].id.indexOf("_changed") == -1) {
                    if (
                      ids[0] == layerId &&
                      data.row == ids[1] &&
                      data.col == ids[2]
                    ) {
                      canvasCtn[j].remove();
                      j = j - 1;
                    }
                  }
                }
              }
            }
            startDraw(data.row, data.col, data.offset, data.data, [], data.layerId, "redraw", 0);
          }
        }
      });
      ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.layerId != layerId);
      await getChangedData(layerId, "redraw");
      resolve();
    });
  },
  /**修改单个符号渲染 */
  resetSingleSymbobolRender(layerId, attr) {
    var nwTileData = TileData.filter(ele => ele.layerId == layerId);
    var index = -1;
    var data;
    var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
    let layerSym = JSON.parse(layerInfo.Symbol);
    var isRender = false;
    if (layerSym.hasOwnProperty("FieldName")) {
      isRender = true;
    }

    for (var i = 0; i < nwTileData.length; i++) {
      var alldata = nwTileData[i].data.J;
      if (nwTileData[i].data.J) {
        var alldata = nwTileData[i].data.J;
        for (var j = 0; j < alldata.length; j++) {
          // var nwTileDataIndex = alldata.findIndex(ele => ele.O == attr.ID);

          let index = keys.findIndex(key => key === alldata[j].O + "");
          // var attrValue = res[keys[index]];
          if (index > -1) {
            if (isRender) {
              if (getPageType() == 0) {
                nwTileData[i].data.J[index].A = attr[layerSym.FieldName];
              } else {
                var temp = layerSym.Symbols;
                var symIndex = layerSym.Symbols.findIndex(
                  ele => ele.Value == attr[layerSym.FieldName]
                );
                if (index > -1) {
                  nwTileData[i].data.J[index].A = symIndex + 1;
                } else {
                  nwTileData[i].data.J[index].A = 1;
                }
              }
            }
            data = nwTileData[i];
            break;
          }
        }
      }
    }
    //重绘变化的数据
    getChangedData(layerId, "redraw");
  },
  //获取样式
  newGetCanvasStyle(layerInfo, attrValue, symbol) {
    let style = {};
    if (layerInfo.RenderType == "SimpleRender") {
      var newSys = symbol.Symbol;
      if (layerInfo.GeoType === "面") {
        style = getPolygonStyle(newSys, symbol.SymbolType);
      } else if (layerInfo.GeoType === "线") {
        style = getPolylineStyle(newSys);
      } else {
        style = getPointStyle(newSys, symbol.SymbolType);
      }
    } else {
      let allSymbols = symbol.Symbols;
      var newSys;
      let index = -1;
      if (layerInfo.RenderType === "UniqueRender") {
        index = allSymbols.findIndex(sym => sym.Value === attrValue);
      } else {
        index = allSymbols.findIndex(ele => {
          let arr = ele.Value.split("-");
          return (
            parseFloat(attrValue) > parseFloat(arr[0]) &&
            parseFloat(attrValue) <= parseFloat(arr[1])
          );
        });
      }
      newSys = index > -1 ? allSymbols[index] : allSymbols[0];
      if (newSys) {
        if (layerInfo.GeoType == "面") {
          style = getPolygonStyle(newSys.Symbol, newSys.SymbolsType);
        } else if (layerInfo.GeoType == "线") {
          style = getPolylineStyle(newSys.Symbol);
        } else {
          style = getPointStyle(newSys.Symbol, newSys.SymbolsType);
        }
      }
    }
    return style;
  },
  /**
   * 行列简单符号渲染绘制封装方法
   * @param {*图层id} layerId
   * @param {*行} row
   * @param {*列} col
   * @param {*} canvas
   * @param {*图层信息} layerInfo
   * @param {*图形数据} data
   * @param {*是否缓存} type
   * @param {*鼠标操作类型} mouseType
   * @param {*缩放比例操作时间} firstTimestamp
   * @param {*图形样式} style
   * @param {*图形填充样色} color
   * @param {*画布上下文} context
   * @param {*转化后的渲染值ids} keys
   * @param {*获取的渲染键值} res
   * @param {*图形符号} symbol
   * @param {*绘制类型} drawType:export
   * @returns
   */
  async drawOnCanvas_noRenderDraw(layerId, row, col, canvas, layerInfo, data, type,
    mouseType,
    firstTimestamp,
    style,
    color,
    context,
    keys,
    res,
    symbol,
    drawType
  ) {

    ZHT_ExportImgCount++;

    /************以下代码开启会导致拖拽切片模式的图层到地图，无法显示****/
    // if (store.state.curCheckedLayerId === layerId) {
    //   return;
    // } else {
    //   startDrawText();
    // }
    /***************************************************************/

    startDrawText();

    for (var i = 0; i < data.J.length; i++) {
      if (data.J[i].G == null || data.J[i].G.length == 0) {
        continue;
      }
      var repeatIndex = notDrawIDs.findIndex(val => val.layerId == layerId)
      if (repeatIndex > -1) {
        if (notDrawIDs[repeatIndex].IDs.length > 0) {
          if (notDrawIDs[repeatIndex].IDs.find(e => e == data.J[i].O) > -1) {
            continue;
          }
        }
      }

      if (data.J[i].G.length > 0) {
        //唯一值渲染
        if (keys) {
          var index = -1;
          index = keys.findIndex(key => key === data.J[i].O + "");
          //根据渲染取符号
          // var attrIndex = data.J[i].A
          var attrValue = res[keys[index]];
          //获取符号样式
          style = this.newGetCanvasStyle(layerInfo, attrValue, symbol);
          if (layerInfo.GeoType === "线" && style.set.lineStyles && style.set.lineStyles.length) {
            style.set.lineStyles.forEach(async element => {
              if (element) {
                for (let key in element.style) {
                  context[key] = element.style[key];
                }
              }
              await this.drawHandle(layerId, row, col, canvas, layerInfo,
                data,
                type,
                mouseType,
                firstTimestamp,
                element,
                color,
                context, i,
                drawType)
            });
          } else if (layerInfo.GeoType === "面" && style.set.lineStyles && style.set.lineStyles.length) {
            style.set.lineStyles.forEach(async element => {
              if (element) {
                for (let key in element.style) {
                  context[key] = element.style[key];
                }
              }
              await this.drawHandle(layerId, row, col, canvas, layerInfo,
                data,
                type,
                mouseType,
                firstTimestamp,
                element,
                color,
                context, i,
                drawType)
            });

          } else {
            if (style) {
              for (let key in style.style) {
                context[key] = style.style[key];
              }
            }
            this.drawHandle(layerId, row, col, canvas, layerInfo,
              data,
              type,
              mouseType,
              firstTimestamp,
              style,
              color,
              context, i,
              drawType)
          }
        } else {
          this.drawHandle(layerId, row, col, canvas, layerInfo,
            data,
            type,
            mouseType,
            firstTimestamp,
            style,
            color,
            context, i,
            drawType)
        }

        //挖空
        if (layerInfo.GeoType == "面") {
          context.fill();
          context.stroke();
        }

      }
      if (i === data.J.length - 1) {
        if (type != "cache") {
          if (allTotalLayerHasPosted >= allTotalLayerPost) {
            startDrawText();
            stopDrawText();
          }
        }
      }
    }
    // },300)
  },
  async drawHandle(layerId, row, col, canvas, layerInfo, data, type, mouseType, firstTimestamp, style, color, context, i, drawType) {
    //是否有选中的数据，若有，重绘
    if (selectedIdData.length > 0 && type != "cache") {
      if (current_tool != "movepolygons") {
        redrawSelectedCanvas(
          "screen",
          data.J[i],
          layerId,
          row,
          col,
          layerInfo.GeoType
        );
      }
    }

    context.beginPath();
    for (var k = 0; k < data.J[i].G.length; k++) {
      // if (store.state.curCheckedLayerId === layerId) {
      //   return;
      // }
      var singledata = data.J[i].G[k];
      singledata = singledata.filter(ele => {
        return ele != null;
      });
      if (layerInfo.GeoType == "面") {
        // if (singledata.length < 4) {
        //   continue;
        // }
      } else if (layerInfo.GeoType == "线") {
        if (singledata.length < 2) {
          continue;
        }
      }
      if (mouseType == "scale") {
        //取消绘制
        if (firstTimestamp != zoomEndTimestamp) {
          stopDrawText();
          return false;
        }
      }
      //当前正在绘制第N组图形的起点
      for (var j = 0; j < singledata.length; j++) {
        if (store.state.stopLoading) return;
        if (layerInfo.GeoType == "点") {
          // var rowcol = getRowCol(map.extent);
          var x = singledata[j][0] + pointSpace;
          var y = singledata[j][1] + pointSpace;
          if (drawType === "export") {
            // 切片位置转屏幕位置
            var offset = getCoordByRowCol(row, col);
            var screen_offset = this.exportExentToScreen(layerInfo);
            // 全屏去掉pointSpace，切片时候才需要
            x = x + offset.offsetX - screen_offset.x - pointSpace;
            y = y + offset.offsetY - screen_offset.y - pointSpace;
          }
          //绘制缓存point
          if (type == "cache") {
            if (style.set.url) {
              context.arc(
                x + cacheImageOffset,
                y + cacheImageOffset,
                style.set.width / 2,
                0,
                Math.PI * 2
              );
            } else {
              color = getColor(i + 1);
              var _style = this.deepClone(style);
              _style.set.color = color;
              pointCtx.ctx.iconFont(
                canvas,
                pointCtx.ctx.iconFontStyle(_style, x, y)
              );
            }
          } else {
            if (style.set.url) {
              // await loadCompleted(style.set.url).then(img => {
              context.drawImage(
                style.set.image,
                x - style.set.width / 2,
                y - style.set.width / 2,
                style.set.width,
                style.set.height
              );
              // });
            } else {
               
              pointCtx.ctx.iconFont(
                canvas,
                pointCtx.ctx.iconFontStyle(style, x, y)
              );
            }
          }
        } else {
          var x = singledata[j][0];
          var y = singledata[j][1];

          if (drawType === "export") {
            // 切片位置转屏幕位置
            var offset = getCoordByRowCol(row, col);
            var screen_offset = this.exportExentToScreen(layerInfo);

            x = x + offset.offsetX - screen_offset.x;
            y = y + offset.offsetY - screen_offset.y;
          }
          // 当线有符号出现时，需要增加偏移量（符号显示不全问题） 导出的时候不需要偏移
          if (layerInfo.GeoType === "线" && drawType != "export") {
            x = x + pointSpace;
            y = y + pointSpace;
          }
          if (singledata.length < 2) {
            context.moveTo(x, y);
            context.lineTo(x + 1, y);
          } else {
            if (j == 0) {
              context.moveTo(x, y);
              ZHT_SecLastCoordinate = [x, y]
              this.initLineSymbol(x, y);
            } else {
              if (layerInfo.GeoType === "线") {
                if (style.set.unicode || style.set.image) {
                  if (type == "cache") {
                    // color = getColor(i + 1);
                  } else {
                    color = ""
                    this.drawLineSymbol(x, y, style, "", canvas, color, context, type)
                  }
                } else {
                  context.lineTo(x, y);
                }
              } else {
                context.lineTo(x, y);
              }
            }
          }
        }
      }
      //将末尾的点重新连接到起始点，形成闭合效果
      if (type == "cache") {
        color = getColor(i + 1);
        if (layerInfo.GeoType == "面") {
          context.strokeStyle = color;
          context.fillStyle = color;
          if (!comTool.tools.empty(style)) {
            context.setLineDash(style.set.lineDash);
          }
          // context.fill();
          // context.stroke();
          context.closePath();
        } else if (layerInfo.GeoType == "线") {
          context.setLineDash(style.set.lineDash);
          context.strokeStyle = color;
          context.lineWidth = style.style.lineWidth + 10;
          context.stroke();
        } else {
          context.fillStyle = color;
          context.strokeStyle = color;
          context.fill();
          context.stroke();
          context.closePath();
        }
      } else {
        if (layerInfo.GeoType === "面") {
          if (!comTool.tools.empty(style)) {
            context.setLineDash(style.set.lineDash);
            if (style.set.url && style.set.image) {
              // style.set.image.src = style.set.url;
              style.set.image.width = style.set.width;
              style.set.image.height = style.set.height;
              context.fillStyle = context.createPattern(style.set.image, "repeat");
              if (style.set.bgroundColor != "rgba(0,0,0,0)") {
                style.set.image.backgroundColor = style.set.bgroundColor;
                context.fillStyle = style.set.bgroundColor
              }
            }
          }
          context.fill();
          if (style.style.lineWidth) {
            context.stroke();
          }
          context.closePath();

        } else if (layerInfo.GeoType == "线") {
          context.setLineDash(style.set.lineDash);
          context.stroke();
        }
      }
    }

  },
  /**
   * 绘制缓存数据库数据简单符号渲染绘制封装方法（缓存数据）
   * @param {*} layerId
   * @param {*} canvas 临时的canvas
   * @param {*} layerInfo
   * @param {*} data 数据库数据
   * @param {*} style 样式
   * @param {*} context  canvas的context
   * @param {*} cacheContext 缓存的context
   * @param {*} esriModule
   * @param {*} realCanvas 显示的/真实的canvas
   * @param {*} cacheCanvas 缓存canvas
   * @param {*} drawType 导出图片时候需要传的绘制类型“export”
   * @param {*} keys 渲染值的key
   * @param {*} res 获取到的渲染值
   * @param {*} symbol 当前图层的符号
   */
  async drawData_Changed_noRenderDraw(layerId, canvas, layerInfo, data, style, context, cacheContext, esriModule, realCanvas, cacheCanvas, drawType, keys, res, symbol) {
    //绘制数据
    for (var i = 0; i < data.length; i++) {
      //是否有选择的数据，有，重绘选中的数据
      if (selectedIdData.length > 0) {
        redrawSelectedCanvas("vector", data[i], layerId, 0, 0, layerInfo.GeoType);
      }
      // 唯一值/分级渲染
      if (keys) {
        let index = keys.findIndex(key => key === data[i].Attr.ID + "");
        var attrValue = res[keys[index]];
        style = getAttrStyle(layerInfo, attrValue, symbol);

        for (let key in style.style) {
          context[key] = style.style[key];
        }
        if (layerInfo.GeoType === "线" && style.set.lineStyles && style.set.lineStyles.length) {

          style.set.lineStyles.forEach(async item => {
            for (let key in item.style) {
              context[key] = item.style[key];
            }
            // console.log(style,'转换后数据')
            await this.drawChangedHandle(item, layerInfo, context, cacheContext, canvas, cacheCanvas, data, esriModule, i, drawType, 'onlyOne')
            // await this.drawChangedHandle(style, layerInfo, context, cacheContext, canvas, cacheCanvas, data, esriModule, i, drawType,'onlyOne')
          })
        } else if (layerInfo.GeoType === "面") {
          if (style.set.lineStyles && style.set.lineStyles.length) {
            style.set.lineStyles.forEach(async val => {
              for (let key in val.style) {
                context[key] = val.style[key];
                this.drawChangedHandle(style, layerInfo, context, cacheContext, canvas, cacheCanvas, data, esriModule, i, drawType)
              }
            })
          } else {
            this.drawChangedHandle(style, layerInfo, context, cacheContext, canvas, cacheCanvas, data, esriModule, i, drawType)
          }
        } else {
          await this.drawChangedHandle(style, layerInfo, context, cacheContext, canvas, cacheCanvas, data, esriModule, i, drawType)
        }
      } else {
        // console.log(style,'简单渲染数据')
        this.drawChangedHandle(style, layerInfo, context, cacheContext, canvas, cacheCanvas, data, esriModule, i, drawType)
      }
    }

    var pdiv = document.querySelector("#mapView");
    const ctx = realCanvas.getContext("2d");
    realCanvas.style.top = "0px"
    realCanvas.style.left = "0px"

    if (drawType != "export") {
      realCanvas.width = pdiv.clientWidth;
      realCanvas.height = pdiv.clientHeight;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

    } else {
      realCanvas.width = canvas.width;
      realCanvas.height = canvas.height;
    }

    ctx.drawImage(canvas, 0, 0);

    //修改各div和canvas偏移量
    realCanvas.parentElement.style.top = "0px";
    realCanvas.parentElement.style.left = "0px";
    var ctnelement = realCanvas.parentElement.childNodes;
    if (ctnelement && ctnelement.length > 0) {
      var ele = ctnelement;
      for (var k = 0; k < ele.length; k++) {
        if (ele[k].id.indexOf("changed") == -1) {
          var ids = ele[k].id.split("_");
          var eLayerId = +ids[0];
          var eRow = +ids[1];
          var eCol = +ids[2];
          //全局数据在当前范围的行列要做偏移
          var offset = getCoordByRowCol(eRow, eCol);

          ele[k].style.left = offset.offsetX + "px";
          ele[k].style.top = offset.offsetY + "px";
          if (layerInfo.GeoType === "点" || layerInfo.GeoType === "线") {
            ele[k].style.left = offset.offsetX - pointSpace + "px";
            ele[k].style.top = offset.offsetY - pointSpace + "px";
          }

        }
      }
    }

    if (allTotalLayerHasPosted == allTotalLayerPost) {
      stopDrawText();
    }
  },
  /**
   *  数据库绘制处理方法
   * @param {*} style
   * @param {*} layerInfo
   * @param {*} context
   * @param {*} cacheContext
   * @param {*} canvas
   * @param {*} cacheCanvas
   * @param {*} data
   * @param {*} esriModule
   * @param {*} i
   * @param {*} drawType
   * @returns
   */
  async drawChangedHandle(style, layerInfo, context, cacheContext, canvas, cacheCanvas, data, esriModule, i, drawType, interWay) {
     
    //只绘制部分要素图形
    if (layerInfo.VisibleIDs != null && layerInfo.VisibleIDs.length > 0 && layerInfo.VisibleIDs.indexOf(data[i].ID) == -1) {
      return
    }

    //开始绘制
    context.beginPath();
    //缓存context
    if (cacheContext) {
      cacheContext.beginPath();
    }
    var color = getColor(i + 1);
    var rings = data[i].Shape; //范围

    for (var j = 0; j < rings.length; j++) {
      if (store.state.stopLoading) return;
      var single = rings[j];
      for (var k = 0; k < single.length; k++) {
        var point = new esriModule.Point(
          single[k][0],
          single[k][1],
          map.spatialReference
        );
        var screenPoint = map.toScreen(point);
        var x = screenPoint.x;
        var y = screenPoint.y;
        if (drawType === "export") {
          // 导出大图 减去 选择框的xy距离
          var pt = this.exportExentToScreen(layerInfo)
          x = screenPoint.x - pt.x
          y = screenPoint.y - pt.y
        }

        if (layerInfo.GeoType === "点") {
          if (style.set.url) {
            context.drawImage(
              style.set.image,
              x - style.set.width / 2,
              y - style.set.width / 2,
              style.set.width,
              style.set.height
            );
            // });
            if (cacheContext) {
              cacheContext.fillStyle = color;
              cacheContext.strokeStyle = color;
              cacheContext.arc(
                x + cacheImageOffset,
                y + cacheImageOffset,
                style.set.width / 2,
                0,
                Math.PI * 2
              );
              cacheContext.fill();
              cacheContext.stroke();
              cacheContext.closePath();
            }
          } else {

            pointCtx.ctx.iconFont(
              canvas,
              pointCtx.ctx.iconFontStyle(style, x, y)
            );

            /** 拾取缓存canvas */
            if (cacheCanvas) {
              var _style = this.deepClone(style);
              _style.set.color = color;
              pointCtx.ctx.iconFont(
                cacheCanvas,
                pointCtx.ctx.iconFontStyle(_style, x, y)
              );
            }
            /** end */
          }
        } else {
          //线面
          if (k == 0) {
            context.moveTo(x, y);
            if (cacheContext)
              cacheContext.moveTo(x, y);
            if (layerInfo.GeoType === "线") {
              lastLineCoordinate = [x, y]
              ZHT_CacheChangedLastLineCoordinate = [x, y]
              this.initLineSymbol(x, y)
            }
          } else {
            if (layerInfo.GeoType === "线") {

              if (style.set.unicode || style.set.image) {
                this.drawChangeLineSymbol(x, y, style, "", canvas, "", context);
                /** 拾取缓存canvasStyle */
                if (cacheContext) {
                  this.cacheDrawChangeLineSymbol(x, y, style, cacheCanvas, "", color, "", cacheContext);
                }
              } else {
                context.lineTo(x, y);
                if (cacheContext)
                  cacheContext.lineTo(x, y);
              }
            } else {
              context.lineTo(x, y);
              if (cacheContext)
                cacheContext.lineTo(x, y);
            }

          }
        }
      }
    }

    //样式设置
    if (layerInfo.GeoType == "面") {
      if (style.set.url) {
        style.set.image.width = style.set.width;
        style.set.image.height = style.set.height;
        context.fillStyle = context.createPattern(style.set.image, "repeat");
        if (style.set.bgroundColor != "rgba(0,0,0,0)") {
          style.set.image.backgroundColor = style.set.bgroundColor;
          context.fillStyle = style.set.bgroundColor
        }
      }
      //判断是否带荧光效果
      if (style.style.isflu) {
        context.shadowColor = style.style.fluorescence
        context.shadowBlur = 5
        context.fill();
        if (style.style.lineWidth) {
          context.stroke();
        }
        context.shadowColor = style.style.fluorescence
        context.shadowBlur = 10
        context.fill();
        if (style.style.lineWidth) {
          context.stroke();
        }
        context.shadowColor = style.style.fluorescence
        context.shadowBlur = 20
        context.fill();
        if (style.style.lineWidth) {
          context.stroke();
        }
      } else {
        context.fill();
        if (style.style.lineWidth) {
          context.stroke();
        }
      }



      context.closePath();
      /** 拾取缓存canvas*/
      if (cacheContext) {
        cacheContext.fillStyle = color;
        cacheContext.strokeStyle = color;
        cacheContext.lineWidth = style.style.lineWidth;
        cacheContext.fill();
        cacheContext.stroke();
        cacheContext.closePath();
      }
      /**end --------*/
    } else if (layerInfo.GeoType == "线") {
      context.setLineDash(style.set.lineDash);
      //判断是否带荧光效果
      if (style.style.isflu) {
        context.shadowColor = style.style.fluorescence
        context.shadowBlur = 5
        context.stroke();
        context.shadowColor = style.style.fluorescence
        context.shadowBlur = 10
        context.stroke();
        context.shadowColor = style.style.fluorescence
        context.shadowBlur = 20
        context.stroke();
      } else {
        context.stroke();
      }

      //缓存
      if (cacheContext) {
        cacheContext.strokeStyle = color;
        cacheContext.lineWidth = style.style.lineWidth + 15;
        cacheContext.stroke();
      }

    }

  },
  /**
   * 绘制线符号 切片
   * @param {*} x
   * @param {*} y
   * @param {*} style
   */
  drawLineSymbol(x, y, style, cacheCanvas, canvas, color, context, type) {
    var x2 = ZHT_SecLastCoordinate[0],
      y2 = ZHT_SecLastCoordinate[1];
    this.setUpLineSymbol(x, y, x2, y2, style, cacheCanvas, canvas, color, context, type);
    ZHT_SecLastCoordinate = [x, y]
  },
  /**
   * 线缓存绘制线符号 切片
   * @param {*} x
   * @param {*} y
   * @param {*} style
   */
  drawCacheLineSymbol(x, y, style, cacheCanvas, canvas, color, context, ) {
    var x2 = ZHT_CacheLastCoordinate[0],
      y2 = ZHT_CacheLastCoordinate[1];
    this.setUpLineSymbol(x, y, x2, y2, style, cacheCanvas, canvas, color, "", context);
    ZHT_CacheLastCoordinate = [x, y]
  },
  /**
   * 数据库绘制线符号
   * @param {*} x
   * @param {*} y
   * @param {*} style
   */
  async drawChangeLineSymbol(x, y, style, cacheCanvas, canvas, color, context, cacheContext, type) {
    var x2 = lastLineCoordinate[0],
      y2 = lastLineCoordinate[1];
    this.setUpLineSymbol(x, y, x2, y2, style, cacheCanvas, canvas, color, context, cacheContext, type);
    lastLineCoordinate = [x, y]
  },


  /**
   * 缓存绘制复合线上符号的处理方法
   * @param {*} x
   * @param {*} y
   * @param {*} style
   * @param {*} cacheCanvas
   * @param {*} canvas
   * @param {*} color
   * @param {*} context
   * @param {*} cacheContext
   */
  async cacheDrawChangeLineSymbol(x, y, style, cacheCanvas, canvas, color, context, cacheContext) {
    // 获取上一次的坐标
    var x2 = ZHT_CacheChangedLastLineCoordinate[0],
      y2 = ZHT_CacheChangedLastLineCoordinate[1];
    this.setUpLineSymbol(x, y, x2, y2, style, cacheCanvas, canvas, color, context, cacheContext);
    // 保存当前坐标为上一次坐标
    ZHT_CacheChangedLastLineCoordinate = [x, y]
  },


  /**
   * 复合线符号处理
   * @param {*} x 当前的x
   * @param {*} y
   * @param {*} x2 上一次的x
   * @param {*} y2
   * @param {*} style
   * @param {*} cacheCanvas
   * @param {*} canvas
   * @param {*} color 拾取时候传入的颜色 固定
   * @param {*} context
   * @param {*} cacheContext
   * @param {*} type "pickup" 拾取  "cache" 缓存
   */
  async setUpLineSymbol(x, y, x2, y2, style, cacheCanvas, canvas, color, context, cacheContext, type) {

    // if(style.set.lineStyles){
    //   style = style.set.lineStyles[2]
    // }else{
    //   style = style
    // }
    // console.log(style,'画点')
    var contextTemp = context
    if (cacheContext) {
      contextTemp = cacheContext
    }
    const _angle = style.angle
    // 方向角度
    var radian = Math.atan2(y - y2, x - x2);
    const angle = 180 / Math.PI * radian;
    // 中点
    // var centerX = (x + x2) / 2,
    // centerY = (y + y2) / 2;
    // 两点之间的距离
    var pointSpace = this.getSpaceLength([x2, y2], [x, y]);

    if (style.set.space && pointSpace >= style.set.space) {
      ZHT_recLineSpaceCount = 0;
      var length = Math.trunc(pointSpace / style.set.space);
      for (let index = 0; index < length; index++) {
        // 方向
        var a2 = this.getLineDirection(angle, style.set.space * (index + 1))[0];
        var b2 = this.getLineDirection(angle, style.set.space * (index + 1))[1];
        // 处理旋转角度
        let angleTemp = _angle;
        if (style.set.lineDirection) { //延线方向并且旋转角度
          angleTemp = angle + 90 + _angle;
        }
        style.set.angle = angleTemp;
        var pointX = a2 + x2;
        var pointY = b2 + y2;

        this.pointDrawHandle(pointX, pointY, style, context, cacheContext, color, canvas, cacheCanvas, type)
      }

    } else {
      /*距离小于space，记录*/
      var lastX = ZHT_recLineLastCoordinate[0],
        lastY = ZHT_recLineLastCoordinate[1];
      //两点距离
      var pointSpace2 = this.getSpaceLength(ZHT_recLineLastCoordinate, [x, y]);
      ZHT_recLineSpaceCount = ZHT_recLineSpaceCount + pointSpace2
      if (ZHT_recLineSpaceCount >= style.set.space) {
        //与上一个坐标距离
        var space = pointSpace2 - (ZHT_recLineSpaceCount - style.set.space);
        var radian1 = Math.atan2(y - lastY, x - lastX);
        const spaceAngle = 180 / Math.PI * radian1;
        // 方向
        var a2 = this.getLineDirection(spaceAngle, space)[0];
        var b2 = this.getLineDirection(spaceAngle, space)[1]; //邻边
        // 处理旋转角度
        let angleTemp = _angle;
        if (style.set.lineDirection) { //延线方向并且旋转角度
          angleTemp = angle + 90 + _angle;
        }
        style.set.angle = angleTemp;
        var pointX = a2 + lastX;
        var pointY = b2 + lastY;

        this.pointDrawHandle(pointX, pointY, style, context, cacheContext, color, canvas, cacheCanvas, type)
        ZHT_recLineSpaceCount = ZHT_recLineSpaceCount - style.set.space;
      }
    }
    ZHT_recLineLastCoordinate = [x, y];
  },


  /**
   * 获取线方向
   * @param {*} angle
   * @param {*} space
   * @returns
   */
  getLineDirection(angle, space) {
    var angle2 = angle;
    if (angle > 90) {
      angle2 = -(360 - angle)
    }
    var radian2 = angle2 / (180 / Math.PI);
    var a2 = Math.cos(radian2) * space; //对
    var b2 = Math.sin(radian2) * space; //邻
    return [a2, b2]
  },
  /**
   * 获取两点距离
   * @param {* 上一次的坐标[x2,y2]} lastCoordinate
   * @param {当前坐标x*} curCoordinate
   * @returns
   */
  getSpaceLength(lastCoordinate, curCoordinate) {
    var lastX = lastCoordinate[0],
      lastY = lastCoordinate[1];
    var x = curCoordinate[0],
      y = curCoordinate[1]
    //两点距离
    var _a = x - lastX;
    var _b = y - lastY;
    var length = Math.sqrt(_a * _a + _b * _b);
    return length;
  },
  /**
   * 复合线符号点绘制
   * @param {*} pointX
   * @param {*} pointY
   * @param {*} style
   * @param {*} context
   * @param {*} contextTemp
   * @param {*} color
   * @param {*} canvas
   * @param {*} cacheCanvas
   */
  async pointDrawHandle(pointX, pointY, style, context, cacheContext, color, canvas, cacheCanvas, type) {
    // console.log(style,'绘制')
    if (style.set.url && context) {
      if (color && type === "pickup") {
        // context.fillStyle = color;
        // context.strokeStyle = color;
        // context.arc(
        //   pointX + cacheImageOffset,
        //   pointY + cacheImageOffset,
        //   style.set.width / 2,
        //   0,
        //   Math.PI * 2
        // );
        // context.fill();
        // context.stroke();
        // context.closePath();
      } else {
        if (type === "cache") {
          context.fillStyle = color;
          context.arc(
            pointX + cacheImageOffset,
            pointY + cacheImageOffset,
            style.set.width / 2,
            0,
            Math.PI * 2
          );
          context.fill();
        } else {
          // await loadCompleted(style.set.url).then(img => {
          context.drawImage(
            style.set.image,
            pointX - style.set.width / 2,
            pointY - style.set.height / 2,
            style.set.width,
            style.set.height
          );
          // });
        }

      }
    }

    if (style.set.unicode) {
      var _style = this.deepClone(style);
      if (color) {
        _style.set.color = color;
        _style.style.fillStyle = color;
      }

      if (canvas) {
        pointCtx.ctx.iconFont(
          canvas,
          pointCtx.ctx.iconFontStyle(_style, pointX, pointY)
        );
      }

      if (cacheCanvas) {
        //数据库数据绘制缓存
        pointCtx.ctx.iconFont(
          cacheCanvas,
          pointCtx.ctx.iconFontStyle(_style, pointX, pointY)
        );
      }
    }

  },
  /**
   *  初始化线符号小于50记录
   * @param {*} x
   * @param {*} y
   */
  initLineSymbol(x, y) {
    ZHT_recLineLastCoordinate = [x, y];
    ZHT_recLineSpaceCount = 0;
  },
  /**
   * redrawData 绘制选择的数据 简单渲染 （行列）
   * @param {*} layerInfo
   * @param {*} canvas
   * @param {*} newdata
   * @param {*} name
   * @param {*} style
   * @returns
   */
  redrawData_noRender(layerInfo, canvas, newdata, name, style) {
    var alldata = newdata.data;
    // canvas = layerInfo.GeoType === "点" ? document.getElementById(name + '_point_changed') : document.getElementById(name + '_' + newdata.row + "_" + newdata.col);
    canvas = document.getElementById(
      name + "_" + newdata.row + "_" + newdata.col
    );
    var pointSelectedCanvas, lineSelectedCanvas;
    if (layerInfo.GeoType == "点") {
      pointSelectedCanvas = document.getElementById(
        name + "_" + newdata.row + "_" + newdata.col + "_point"
      );
    }
    var context = "",
      pointContext = "";
    if (pointSelectedCanvas) {
      pointContext = pointSelectedCanvas.getContext("2d");
      pointContext.beginPath();
    }

    if (canvas) {
      context = canvas.getContext("2d");
      context.beginPath();
    }

    if (layerInfo.GeoType === "线") {
      lineSelectedCanvas = document.getElementById(
        name + "_" + newdata.row + "_" + newdata.col + "_line"
      );
      context = lineSelectedCanvas.getContext("2d");
      context.beginPath();
    }

    if (!context) {
      return;
    }
    // let _style = this.deepClone(style);
    let _style = JSON.parse(JSON.stringify(style))
    for (var k = 0; k < alldata.length; k++) {
      var data = alldata[k];
      for (var i = 0; i < data.G.length; i++) {
        if (data.G[i] == null || data.G[i].length == 0) {
          continue;
        }
        var singledata = data.G[i];
        // singledata = singledata.filter(ele => {
        //   return ele != null
        // })
        var singleArr = [];
        for (let index = 0; index < singledata.length; index++) {
          var element = singledata[index];
          if (element != null) {
            singleArr.push(element);
          }
        }
        singledata = singleArr;
        var j = 0,
          length = singledata.length;
        for (; j < length; j++) {
          if (layerInfo.GeoType == "点") {
            var x = singledata[j][0] + pointSpace;
            var y = singledata[j][1] + pointSpace;
            if (style.set.url) {
              pointContext.fillStyle = "#00FFFF";
              pointContext.arc(
                x + cacheImageOffset,
                y + cacheImageOffset,
                style.set.width / 2,
                0,
                Math.PI * 2
              );
              pointContext.fill();
              // loadCompleted("../images/arc.png").then((img) => {
              //   context.drawImage(img, singledata[j][0], singledata[j][1], style.set.width, style.set.height);
              // })
            } else {
              _style.set.color = "#00FFFF";
              pointCtx.ctx.iconFont(
                pointSelectedCanvas,
                pointCtx.ctx.iconFontStyle(_style, x, y)
              );
            }
          } else {
            if (layerInfo.GeoType == "面") {
              // if (singledata.length < 4) continue;
            } else {
              if (singledata.length < 2) continue;
            }
            var x = singledata[j][0],
              y = singledata[j][1]
            if (layerInfo.GeoType === "线") {
              x = x + pointSpace;
              y = y + pointSpace;
            }
            if (singledata.length < 2) {
              context.moveTo(x, y);
              context.lineTo(x + 1, y);
            } else {
              if (j == 0) {
                context.moveTo(x, y);
                if (layerInfo.GeoType === "线") {
                  ZHT_CacheLastCoordinate = [x, y]
                  this.initLineSymbol(x, y)
                }
              } else {
                context.lineTo(x, y);
                if (layerInfo.GeoType === "线") {
                  if (!style.set.image || !style.set.unicode)
                    this.drawCacheLineSymbol(x, y, style, "", lineSelectedCanvas, "#00FFFF", context)
                }
              }
            }
          }
        }
        setCanvasPicked(layerInfo.GeoType, context, style);
      }
    }
  },
  /**
   * 对点和线的canvas偏移操作,  移除超出canvas和修改还在屏幕内canvas的偏移量
   * @param {*} name 类名
   */
  resetPointPickedCanvasByDrag(name) {
    var rowcol = getRowCol(map.extent);
    var ctnelement = document.getElementsByClassName(name + "Layer");
    if (ctnelement && ctnelement.length > 0) {
      var ele = ctnelement;
      for (var k = 0; k < ele.length; k++) {
        if (ele[k].id.indexOf("changed") == -1) {
          var ids = ele[k].id.split("_");
          var eRow = parseInt(ids[1]);
          var eCol = parseInt(ids[2]);
          if (ids[3] === "point" || ids[3] === "line") {
            //超出屏幕范围移除
            if (
              eRow < rowcol.minRow ||
              eRow > rowcol.maxRow ||
              eCol < rowcol.minCol ||
              eCol > rowcol.maxCol
            ) {
              ele[k].remove();
              k = k - 1;
              //删除超出范围的缓存
              var index = TileCanvasCache.findIndex(ele => {
                return ele.row == eRow && ele.col == eCol;
              });
              if (index > -1) {
                TileCanvasCache.splice(index, 1);
              }
            } else if (
              eRow >= rowcol.minRow &&
              eRow <= rowcol.maxRow &&
              eCol >= rowcol.minCol &&
              eCol <= rowcol.maxCol
            ) {
              var offset = getCoordByRowCol(eRow, eCol);
              ele[k].style.left = offset.offsetX - pointSpace + "px";
              ele[k].style.top = offset.offsetY - pointSpace + "px";
            }
          }
        }
      }
    }

    //缓存偏移量修改，应该不必要，暂时注释
    if (name != "highlight")
      return;
    for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
      for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
        var offset = getCoordByRowCol(i, j);
        var index = TileCanvasCache.findIndex(ele => {
          return ele.row == i && ele.col == j;
        });
        if (index > -1) {
          TileCanvasCache[index].cacheCanvas.style.left = offset.offsetX + "px";
          TileCanvasCache[index].cacheCanvas.style.top = offset.offsetY + "px";
        }
      }
    }
  },
  /**
   * 过滤树形数据初始化图层标记 按照比例尺缩放 isShowLayer
   * @param {*} dataTrees
   * @param {*} layerId
   * @param {*} flag
   */
  filterDataTrees(dataTrees, layerId, flag) {
    if (dataTrees.length) {
      dataTrees.forEach(data => {
        if (data.id === layerId && data.type === "shapefileLayer") {
          data.isShowLayer = flag;
        }
        if (data.children && data.children.length > 0) {
          this.filterDataTrees(data.children, layerId, flag);
        }
        return true;
      });
    }
  },


  /*start 多图形平移功能****************************************************************************
   * 创建一个包含平移图形的画布
   * @param {*}
   * @returns
   */
  async createMoveCanvas(selectedData) {
    //延迟绘制，以便于selectedAllData加入弧线转化后的坐标，注意：如果是大量的弧线平移操作可能会出现问题
    setTimeout(async () => {
      await this.removeMoveCanvas();
      this.redrawMoveGraphic(selectedData);
      this.redrawCacheMoveGraphic(selectedData);
    }, 200);
  },
  /**
   * 移除平移的canvas
   */
  removeMoveCanvas() {
    changedCacheContexts = [];
    screenCacheContexts = [];
    var eles = document.getElementsByClassName("moveScreenLayer");
    if (eles && eles.length > 0) {
      var len = JSON.parse(JSON.stringify(eles.length));
      for (let index = 0; index < len; index++) {
        const element = eles[0];
        if (element) {
          var ctx = element.getContext("2d");
          ctx.clearRect(0, 0, element.clientWidth, element.clientHeight);
          element.remove();
        }
      }
    }
    // reloadData();
    // reloadLabelData()
    // var canvasCtn = document.querySelector('.moveLayer_temp');
    // var canvasCtn2 = document.querySelector('.moveLayer');
    // if (canvasCtn2) {
    //   canvasCtn2.innerHTML = "";
    // }
    // if (canvasCtn) {
    //   canvasCtn.innerHTML = "";
    // }
  },

  /**
   *创建平移的canvas
   * @param {*} type
   * @param {行} i
   * @param {列} j
   * @returns
   */
  creadteMoveCanvas(type, geoType, i, j) {
    var div = document.querySelector("#mapView_gc");
    if (div == null) return;
    var vNodes = getVetorLayerNode(store.state.dataTreeData);
    var baseList = store.state.baseTreeData[0].children;
    vNodes = vNodes.reverse();
    var canvasCtn = document.querySelector(".moveLayer");
    var canvasmove = "";
    if (!canvasCtn) {
      canvasCtn = document.createElement("div");
      canvasCtn.className = "moveLayer";
      canvasCtn.style.position = "absolute";
      canvasCtn.style.zIndex = vNodes.length + 6 + baseList.length;
      div.before(canvasCtn);
    }
    if (type == "vector") {
      var changedCanvas = document.getElementById("move_changed");
      if (!changedCanvas) {
        changedCanvas = document.createElement("canvas");
        var pdiv = document.querySelector("#mapView");
        changedCanvas.id = "move_changed";
        changedCanvas.className = "moveScreenLayer";
        changedCanvas.width = pdiv.clientWidth;
        changedCanvas.height = pdiv.clientHeight;
        changedCanvas.style.position = "absolute";
        changedCanvas.style.left = "0px";
        changedCanvas.style.top = "0px";
        changedCanvas.style.cursor = "move";
        canvasCtn.append(changedCanvas);
      }
      canvasmove = changedCanvas;
    } else {
      var offset = getCoordByRowCol(i, j);
      if (geoType != "点") {
        var ele = document.getElementById("moveScreen" + "_" + i + "_" + j);
        if (!ele) {
          ele = document.createElement("canvas");
          ele.className = "moveScreenLayer";
          ele.style.left = offset.offsetX + "px";
          ele.style.top = offset.offsetY + "px";
          ele.setAttribute("id", "moveScreen" + "_" + i + "_" + j);
          ele.width = 256;
          ele.height = 256;
          ele.style.position = "absolute";
          ele.style.cursor = "move";
          canvasCtn.append(ele);
        }
        canvasmove = ele;
      } else {
        var pointEle = document.getElementById(
          "moveScreen" + "_" + i + "_" + j + "_point"
        );
        if (!pointEle) {
          pointEle = document.createElement("canvas");
          pointEle.className = "moveScreenLayer";
          pointEle.style.left = offset.offsetX - pointSpace + "px";
          pointEle.style.top = offset.offsetY - pointSpace + "px";
          pointEle.setAttribute(
            "id",
            "moveScreen" + "_" + i + "_" + j + "_point"
          );
          pointEle.width = pointCanvasWidth;
          pointEle.height = pointCanvasWidth;
          pointEle.style.position = "absolute";
          pointEle.style.cursor = "move";
          canvasCtn.append(pointEle);
        }
        canvasmove = pointEle;
      }
    }
    return canvasmove;
  },
  /**
   *创建平移的缓存拾取的canvas
   * @param {*} type
   * @param {行} i
   * @param {列} j
   * @returns
   */
  creadtePickupMoveCanvas(type, geoType, i, j) {
    var div = document.querySelector("#mapView_gc");
    if (div == null) return;
    var vNodes = getVetorLayerNode(store.state.dataTreeData);
    var baseList = store.state.baseTreeData[0].children;
    vNodes = vNodes.reverse();
    var canvasCtn = document.querySelector(".moveLayer_temp");
    var canvasmove = "";
    if (!canvasCtn) {
      canvasCtn = document.createElement("div");
      canvasCtn.className = "moveLayer_temp";
      canvasCtn.style.position = "absolute";
      canvasCtn.style.zIndex = -2;
      div.before(canvasCtn);
    }
    if (type == "vector") {
      var changedCanvas = document.getElementById("move_changed_temp");
      if (!changedCanvas) {
        changedCanvas = document.createElement("canvas");
        var pdiv = document.querySelector("#mapView");
        changedCanvas.id = "move_changed_temp";
        changedCanvas.className = "moveScreenLayer";
        changedCanvas.width = pdiv.clientWidth;
        changedCanvas.height = pdiv.clientHeight;
        changedCanvas.style.position = "absolute";
        changedCanvas.style.left = "0px";
        changedCanvas.style.top = "0px";
        changedCanvas.style.cursor = "move";
        canvasCtn.append(changedCanvas);
      }
      canvasmove = changedCanvas;
    } else {
      var offset = getCoordByRowCol(i, j);
      if (geoType != "点") {
        if (i && j) {
          var ele = document.getElementById(
            "moveScreen" + "_" + i + "_" + j + "_temp"
          );
          if (!ele) {
            ele = document.createElement("canvas");
            ele.className = "moveScreenLayer";
            ele.style.left = offset.offsetX + "px";
            ele.style.top = offset.offsetY + "px";
            ele.setAttribute("id", "moveScreen" + "_" + i + "_" + j + "_temp");
            ele.width = 256;
            ele.height = 256;
            ele.style.position = "absolute";
            ele.style.cursor = "move";
            canvasCtn.append(ele);
          }
          canvasmove = ele;
        }
      } else {
        if (i && j) {
          var pointEle = document.getElementById(
            "moveScreen" + "_" + i + "_" + j + "_pointTemp"
          );
          if (!pointEle) {
            pointEle = document.createElement("canvas");
            pointEle.className = "moveScreenLayer";
            pointEle.style.left = offset.offsetX - pointSpace + "px";
            pointEle.style.top = offset.offsetY - pointSpace + "px";
            pointEle.setAttribute(
              "id",
              "moveScreen" + "_" + i + "_" + j + "_pointTemp"
            );
            pointEle.width = pointCanvasWidth;
            pointEle.height = pointCanvasWidth;
            pointEle.style.position = "absolute";
            pointEle.style.cursor = "move";
            canvasCtn.append(pointEle);
          }
          canvasmove = pointEle;
        }
      }
    }
    return canvasmove;
  },
  /**
   * 绘制移动图形
   * @param {选中的数据} data
   *
   */
  redrawMoveGraphic(data) {

    var context = "";
    for (let index = 0; index < data.length; index++) {
      const selVal = data[index];
      var layerInfo = store.state.allLayerData.find(
        ele => ele.Id == selVal.layerId
      );
      let layerSym = JSON.parse(layerInfo.Symbol);
      var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";
      var style = this.newGetCanvasStyle(layerInfo, "", symbol);
      var isRender = false;
      if (layerSym.hasOwnProperty("FieldName")) {
        isRender = true;
      }
      if (selVal.type == "vector") {
        if (isRender) {
          this.getUniRenderLabelVals(
            selVal.layerId,
            [selVal.data],
            layerSym.FieldName,
            "Attribute"
          ).then(res => {
            var canvas = this.creadteMoveCanvas(selVal.type, selVal.geoType);
            context = canvas.getContext("2d");
            var keys = Object.keys(res);
            let index = keys.findIndex(key => key === selVal.Id + "");
            var attrValue = res[keys[index]];
            style = getAttrStyle(layerInfo, attrValue, symbol);
            this.vectorDraw(selVal, canvas, context, style, "#00FFFF");
          });
        } else {
          var canvas = this.creadteMoveCanvas(selVal.type, selVal.geoType);
          context = canvas.getContext("2d");
          this.vectorDraw(selVal, canvas, context, style, "#00FFFF");
        }
      } else if (selVal.type == "screen") {
        var rings = selVal.data;
        for (let index = 0; index < rings.length; index++) {
          const ringVal = rings[index];
          if (isRender) {
            this.getUniRenderLabelVals(
              selVal.layerId,
              ringVal.data,
              layerSym.FieldName,
              "Vector"
            ).then(res => {
              var canvas = this.creadteMoveCanvas(
                selVal.type,
                selVal.geoType,
                ringVal.row,
                ringVal.col
              );
              context = canvas.getContext("2d");
              var keys = Object.keys(res);
              for (let k = 0; k < ringVal.data.length; k++) {
                const ringvalVal = ringVal.data[k].G;
                let index = keys.findIndex(
                  key => key === ringVal.data[k].O + ""
                );
                var attrValue = res[keys[index]];
                style = getAttrStyle(layerInfo, attrValue, symbol);
                for (let j = 0; j < ringvalVal.length; j++) {
                  const g = ringvalVal[j];
                  for (let i = 0; i < g.length; i++) {
                    const element = g[i];
                    var x = element[0];
                    var y = element[1];
                    if (selVal.geoType === "点") {
                      var pointX = x + pointSpace;
                      var pointY = y + pointSpace;
                      if (style.set.url) {
                        context.fillStyle = "#00FFFF";
                        context.arc(
                          pointX + cacheImageOffset,
                          pointY + cacheImageOffset,
                          style.set.width / 2,
                          0,
                          Math.PI * 2
                        );
                        context.fill();
                        // loadCompleted("../images/arc.png").then((img) => {
                        //   context.drawImage(img, singledata[j][0], singledata[j][1], style.set.width, style.set.height);
                        // })
                      } else {
                        let _style = this.deepClone(style);
                        _style.set.color = "#00FFFF";
                        pointCtx.ctx.iconFont(
                          canvas,
                          pointCtx.ctx.iconFontStyle(_style, pointX, pointY)
                        );
                      }
                    } else {
                      if (i == 0) {
                        context.moveTo(x, y);
                      } else {
                        context.lineTo(x, y);
                      }
                    }
                  }
                }
              }
              setCanvasPicked(selVal.geoType, context, style);
            });
          } else {
            var canvas = this.creadteMoveCanvas(
              selVal.type,
              selVal.geoType,
              ringVal.row,
              ringVal.col
            );
            context = canvas.getContext("2d");
            for (let k = 0; k < ringVal.data.length; k++) {
              const ringvalVal = ringVal.data[k].G;
              for (let j = 0; j < ringvalVal.length; j++) {
                const g = ringvalVal[j];
                for (let i = 0; i < g.length; i++) {
                  const element = g[i];
                  var x = element[0];
                  var y = element[1];
                  if (selVal.geoType === "点") {
                    var pointX = x + pointSpace;
                    var pointY = y + pointSpace;
                    if (style.set.url) {
                      context.fillStyle = "#00FFFF";
                      context.arc(
                        pointX + cacheImageOffset,
                        pointY + cacheImageOffset,
                        style.set.width / 2,
                        0,
                        Math.PI * 2
                      );
                      context.fill();
                      // loadCompleted("../images/arc.png").then((img) => {
                      //   context.drawImage(img, singledata[j][0], singledata[j][1], style.set.width, style.set.height);
                      // })
                    } else {
                      let _style = this.deepClone(style);
                      _style.set.color = "#00FFFF";
                      pointCtx.ctx.iconFont(
                        canvas,
                        pointCtx.ctx.iconFontStyle(_style, pointX, pointY)
                      );
                    }
                  } else {
                    if (i == 0) {
                      context.moveTo(x, y);
                    } else {
                      context.lineTo(x, y);
                    }
                  }
                }
              }
            }
            setCanvasPicked(selVal.geoType, context, style);
          }
        }
      }
    }
  },
  /**
   * 绘制缓存平移图形
   * @param {选中的数据} data
   *  @param {是否是缓存数据} isCache
   */
  redrawCacheMoveGraphic(data) {
    var context = "";
    changedCacheContexts = [];
    var color = getColor(9999999998);
    for (let index = 0; index < data.length; index++) {
      const selVal = data[index];
      var layerInfo = store.state.allLayerData.find(
        ele => ele.Id == selVal.layerId
      );
      let layerSym = JSON.parse(layerInfo.Symbol);
      var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";

      var style = this.newGetCanvasStyle(layerInfo, "", symbol);
      // var _style = this.deepClone(style);
      var isRender = false;
      if (layerSym.hasOwnProperty("FieldName")) {
        isRender = true;
      }
      if (selVal.type === "vector") {
        if (isRender) {
          this.getUniRenderLabelVals(
            selVal.layerId,
            [selVal.data],
            layerSym.FieldName,
            "Attribute"
          ).then(res => {
            var canvas = this.creadtePickupMoveCanvas(
              selVal.type,
              selVal.geoType
            );
            context = canvas.getContext("2d");
            var contextindex = changedCacheContexts.findIndex(
              ele => ele === context
            );
            if (contextindex === -1) {
              changedCacheContexts.push(context);
            }
            var keys = Object.keys(res);
            let index = keys.findIndex(key => key === selVal.Id + "");
            var attrValue = res[keys[index]];
            style = getAttrStyle(layerInfo, attrValue, symbol);
            this.vectorDraw(selVal, canvas, context, style, color, "cache");
          });
        } else {
          var canvas = this.creadtePickupMoveCanvas(
            selVal.type,
            selVal.geoType
          );
          context = canvas.getContext("2d");
          var contextindex = changedCacheContexts.findIndex(
            ele => ele === context
          );
          if (contextindex === -1) {
            changedCacheContexts.push(context);
          }
          this.vectorDraw(selVal, canvas, context, style, color, "cache");
        }
      } else if (selVal.type === "screen") {
        var rings = selVal.data;
        for (let index = 0; index < rings.length; index++) {
          const ringVal = rings[index];
          if (isRender) {
            this.getUniRenderLabelVals(
              selVal.layerId,
              ringVal.data,
              layerSym.FieldName,
              "Vector"
            ).then(res => {
              var canvas = this.creadtePickupMoveCanvas(
                selVal.type,
                selVal.geoType,
                ringVal.row,
                ringVal.col
              );
              context = canvas.getContext("2d");
              var obj = {
                layerId: selVal.layerId,
                geoType: selVal.geoType,
                cacheContext: context,
                row: ringVal.row,
                col: ringVal.col
              };
              var contextindex = screenCacheContexts.findIndex(
                ele => ele.row === ringVal.row && ele.col === ringVal.col
              );
              if (contextindex === -1) {
                screenCacheContexts.push(obj);
              }
              var keys = Object.keys(res);
              for (let k = 0; k < ringVal.data.length; k++) {
                const ringvalVal = ringVal.data[k].G;
                let index = keys.findIndex(
                  key => key === ringVal.data[k].O + ""
                );
                var attrValue = res[keys[index]];
                style = getAttrStyle(layerInfo, attrValue, symbol);
                for (let j = 0; j < ringvalVal.length; j++) {
                  const g = ringvalVal[j];
                  for (let i = 0; i < g.length; i++) {
                    const element = g[i];
                    var x = element[0];
                    var y = element[1];
                    if (selVal.geoType === "点") {
                      var pointX = x + pointSpace - 6;
                      var pointY = y + pointSpace - 6;
                      if (style.set.url) {
                        context.fillStyle = color;
                        context.arc(
                          pointX + cacheImageOffset,
                          pointY + cacheImageOffset,
                          style.set.width / 2,
                          0,
                          Math.PI * 2
                        );
                        context.fill();
                        // loadCompleted("../images/arc.png").then((img) => {
                        //   context.drawImage(img, singledata[j][0], singledata[j][1], style.set.width, style.set.height);
                        // })
                      } else {
                        let _style = this.deepClone(style);
                        _style.set.color = color;
                        pointCtx.ctx.iconFont(
                          canvas,
                          pointCtx.ctx.iconFontStyle(_style, pointX, pointY)
                        );
                      }
                    } else {
                      if (i == 0) {
                        context.moveTo(x, y);
                      } else {
                        context.lineTo(x, y);
                      }
                    }
                  }
                }
              }
              if (selVal.geoType == "面") {
                /** 拾取缓存canvas*/
                context.fillStyle = color;
                context.strokeStyle = color;
                context.lineWidth = style.style.lineWidth;
                context.fill();
                context.stroke();
                context.closePath();
                /**end */
              } else if (selVal.geoType == "线") {
                //缓存
                context.strokeStyle = color;
                context.lineWidth = style.style.lineWidth + 15;
                context.stroke();
              }
            });
          } else {
            var canvas = this.creadtePickupMoveCanvas(
              selVal.type,
              selVal.geoType,
              ringVal.row,
              ringVal.col
            );
            context = canvas.getContext("2d");
            var obj = {
              layerId: selVal.layerId,
              geoType: selVal.geoType,
              cacheContext: context,
              row: ringVal.row,
              col: ringVal.col
            };
            var contextindex = screenCacheContexts.findIndex(
              ele => ele.row === ringVal.row && ele.col === ringVal.col
            );
            if (contextindex === -1) {
              screenCacheContexts.push(obj);
            }
            for (let k = 0; k < ringVal.data.length; k++) {
              const ringvalVal = ringVal.data[k].G;
              for (let j = 0; j < ringvalVal.length; j++) {
                const g = ringvalVal[j];
                for (let i = 0; i < g.length; i++) {
                  const element = g[i];
                  var x = element[0];
                  var y = element[1];
                  if (selVal.geoType === "点") {
                    var pointX = x + pointSpace - 6;
                    var pointY = y + pointSpace - 6;
                    if (style.set.url) {
                      context.fillStyle = color;
                      context.arc(
                        pointX + cacheImageOffset,
                        pointY + cacheImageOffset,
                        style.set.width / 2,
                        0,
                        Math.PI * 2
                      );
                      context.fill();
                      // loadCompleted("../images/arc.png").then((img) => {
                      //   context.drawImage(img, singledata[j][0], singledata[j][1], style.set.width, style.set.height);
                      // })
                    } else {
                      let _style = this.deepClone(style);
                      _style.set.color = color;
                      pointCtx.ctx.iconFont(
                        canvas,
                        pointCtx.ctx.iconFontStyle(_style, pointX, pointY)
                      );
                    }
                  } else {
                    if (i == 0) {
                      context.moveTo(x, y);
                    } else {
                      context.lineTo(x, y);
                    }
                  }
                }
              }
            }
            if (selVal.geoType == "面") {
              /** 拾取缓存canvas*/
              context.fillStyle = color;
              context.strokeStyle = color;
              context.lineWidth = style.style.lineWidth;
              context.fill();
              context.stroke();
              context.closePath();
              /**end */
            } else if (selVal.geoType == "线") {
              //缓存
              context.strokeStyle = color;
              context.lineWidth = style.style.lineWidth + 15;
              context.stroke();
            }
          }
        }
      }
    }
  },
  // 数据库数据绘制
  vectorDraw(selVal, canvas, context, style, color, type) {
    var esriModule = store.state.esriModule;
    var rings = selVal.data.Shape;
    for (var j = 0; j < rings.length; j++) {
      var single = rings[j];
      for (var k = 0; k < single.length; k++) {
        var point = new esriModule.Point(
          single[k][0],
          single[k][1],
          map.spatialReference
        );
        var screenPoint = map.toScreen(point);
        if (selVal.geoType === "点") {
          if (style.set.url) {
            context.fillStyle = color;
            context.arc(
              screenPoint.x + cacheImageOffset,
              screenPoint.y + cacheImageOffset,
              style.set.width / 2,
              0,
              Math.PI * 2
            );
            context.fill();
          } else {
            let _style = this.deepClone(style);
            _style.set.color = color;
            if (type === "cache") {
              pointCtx.ctx.iconFont(
                canvas,
                pointCtx.ctx.iconFontStyle(
                  _style,
                  screenPoint.x - 4,
                  screenPoint.y - 4
                )
              );
            } else {
              pointCtx.ctx.iconFont(
                canvas,
                pointCtx.ctx.iconFontStyle(_style, screenPoint.x, screenPoint.y)
              );
            }
          }
        } else {
          if (k == 0) {
            context.moveTo(screenPoint.x, screenPoint.y);
          } else {
            context.lineTo(screenPoint.x, screenPoint.y);
          }
        }
      }
    }
    // setCanvasPicked(selVal.geoType, context, style);
    if (selVal.geoType == "面") {
      /** 拾取缓存canvas*/
      context.strokeStyle = color;
      context.fillStyle = type === "cache" ? color : "rgba(0,0,0,0)";
      context.lineWidth = style.style.lineWidth;
      context.fill();
      context.stroke();
      context.closePath();
      /**end */
    } else if (selVal.geoType == "线") {
      //缓存
      context.strokeStyle = color;
      context.lineWidth =
        type === "cache" ? style.style.lineWidth + 15 : style.style.lineWidth;
      context.stroke();
    }
  },

  /**
   *平移拾取
   * @param {*} o
   * @returns
   */
  moveCanvasPickup(evt) {
    // 拾取数据库的canvas
    if (changedCacheContexts.length) {
      for (let index = 0; index < changedCacheContexts.length; index++) {
        const context = changedCacheContexts[index];
        var position = {
          x: evt.x,
          y: evt.y
        };
        var color = getCacheColor(position, context);
        if (color) {
          store.dispatch("setCanMove", true);
        } else {
          this.moveRowColpickUp(evt);
        }
      }
    } else {
      this.moveRowColpickUp(evt);
    }
  },
  /**
   * 平移行列拾取
   * @param {*} layerId
   * @returns
   */
  moveRowColpickUp(evt) {
    var curRowCol = getSingleRowCol(evt.x, evt.y); //当前所在行列
    var tmp = screenCacheContexts.filter(ele => {
      return ele.row == curRowCol.row && ele.col == curRowCol.col;
    });
    if (tmp.length) {
      var position = {
        x: curRowCol.colp,
        y: curRowCol.rowp
      };
      var color = "";
      for (var i = 0; i < tmp.length; i++) {
        if (tmp[i].geoType == "点") {
          var pos = {};
          pos.x = position.x + pointSpace;
          pos.y = position.y + pointSpace;
          if (tmp[i].cacheContext)
            color = getCacheColor(pos, tmp[i].cacheContext);
        } else {
          if (tmp[i].cacheContext)
            color = getCacheColor(position, tmp[i].cacheContext);
        }
        if (color) {
          store.dispatch("setCanMove", true);
        } else {
          store.dispatch("setCanMove", false);
        }
      }
    } else {
      store.dispatch("setCanMove", false);
    }
  },
  /**********************************************************************end*/


  /**
   * 重新加载真实数据（数据库数据）
   * @param {} arr 选中的数据
   */
  async reloadRealityData(layerId, arr) {

    store.dispatch("setStopLoading", false); //解除停止绘制

    await this.clearUniderVals(layerId);

    await DTPLabel.clearLabelCacheVals(layerId);

    clearSelectCanvasByType();

    if (arr && arr.length > 0) {
      resetSelectCanvasByEdit(arr);
    }

    await clearArcLineArr(layerId, null, "layer");

    ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.layerId != layerId);

    //判断是否加相应的参数（渲染、label）
    var para = isAddToParams(layerId);
    var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
    if (layerInfo == undefined) {
      return;
    }
    let coordinate = layerInfo.coordinate;
    var pageType = getPageType();
     
    //转换map的extent
    var extent = map.extent;
    // if (mapCoordinate != coordinate) {
    //   extent = convertMapExtent(coordinate);
    // }
    if (extent == null) {
      return;
    }
    var timeStamp = localStorage.getItem('timestamp' + layerId)
    let params = {
      UserId: store.state.user.userid,
      GDataId: layerInfo.GDataId,
      GDataName: "",
      type: pageType == 1 ? 1 : 0,
      mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
      scale: map.getScale()
      //timestamp: timeStamp
    };
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    cancleToken.push(source);

    await request.getAllTableData(params, source.token).then(res => {
      //保存下次请求的时间戳
      //localStorage.setItem('timestamp' + layerId, res.data.timestamp)
      ZHT_ChangedDelData = res.data.deleteids
      if (res.data != '') {
        var notDrawArr = []
        var deleteArr = []

        if (res.data.lis) {
          for (var i = 0; i < res.data.lis.length; i++) {
            notDrawArr.push(res.data.lis[i].ID) //不绘制的ID
          }
        }
        if (res.data.deleteids) {
          notDrawArr.push(...res.data.deleteids)
          deleteArr.push(...res.data.deleteids) //删除的ID       
        }
      }
      deleteArr = deleteArr ? deleteArr : []
      notDrawArr = notDrawArr ? notDrawArr : []

      var deleteObj = {
        layerId: layerId,
        IDs: deleteArr
      }
      var notDrawObj = {
        layerId: layerId,
        IDs: notDrawArr
      }
      //获取所有删除IDs
      if (deleteIDs.findIndex(val => val.layerId == layerId) > -1) {
        var repeatIndex = deleteIDs.findIndex(val => val.layerId == layerId)
        deleteIDs[repeatIndex].IDs = MergeArray(deleteIDs[repeatIndex].IDs, deleteArr)
      } else {
        deleteIDs.push(deleteObj)
      }
      //获取所有不绘制的IDs
      if (notDrawIDs.findIndex(val => val.layerId == layerId) > -1) {
        var repeatIndex = notDrawIDs.findIndex(val => val.layerId == layerId)
        notDrawIDs[repeatIndex].IDs = MergeArray(notDrawIDs[repeatIndex].IDs, notDrawArr)
      } else {
        notDrawIDs.push(notDrawObj)
      }

      // 处理数据库缓存数据,更新AllChangedData和ChangedData
      if (res.data.lis && res.data.lis.length > 0 || res.data.deleteids && res.data.deleteids.length > 0) {
        updateAllChangedData(res.data.lis, extent, layerId, layerInfo)
      } else {
        //单独更新ChangedData
        updateChangedData(extent, layerId, layerInfo)
      }
      //设置该图层已加载数据
      layerInfo.hasLoadData = true

      var changeD = AllChangedData.find(val => val.layerId === layerId)
      if (changeD) {
        drawChangedData(layerId, extent);
      }
    });
    DTPLabel.reloadLabelData(layerId);
  },


  /**
   * 置顶和置底处理方法
   * @param {数据库数据} data
   * @param {} placeType 放置类型 置顶，置底
   */
  sortChangeHandle(data, layerId) {
    // 置顶
    if (onTopData[layerId] && onTopData[layerId].length > 0) {
      var cData = JSON.parse(JSON.stringify(data));
      for (let i = 0; i < onTopData[layerId].length; i++) {
        const topData = onTopData[layerId][i];
        var dataIndex = cData.findIndex(val => val.ID === topData);
        if (dataIndex > -1) {
          if (placeType === "up") {
            data.push(cData[dataIndex]);
            data.splice(dataIndex - i, 1);
          } else {
            data.unshift(cData[dataIndex]);
            data.splice(dataIndex + i, 1);
          }
        }
      }
    }
    return data;
  },
  /**
   * 不选中处理(数据库数据)
   * @param {绘制的数据} newData
   */
  notVectorSelectedHandle(newData, layerId, selectIds, obj) {
    // console.log(layerId, obj)
    var selectedData = selectedAllData.filter(val => val.type === "vector");
    var index = selectedData.findIndex(
      val => val.data.Attr.ID === newData.Attr.ID && val.layerId === layerId
    );
    if (index > -1) {
      //去除已选中的
      selectedData.splice(index, 1);
    } else {
      //选中未选中的
      selectedData.push(obj);
    }
    var layerIndex = selectedIdData.findIndex(val => val.layerId === layerId);
    var idIndex = -1;
    if (layerIndex > -1) {
      var ids = selectedIdData[layerIndex].ids;
      idIndex = ids.findIndex(val => val === newData.Attr.ID);
      if (idIndex > -1) {
        ids.splice(idIndex, 1);
      } else {
        selectIds.push(newData.Attr.ID);
        ids.push(newData.Attr.ID);
      }
    } else {
      selectedIdData.push({
        layerId: layerId,
        ids: [newData.Id]
      });
    }

    var selectedData_screen = selectedAllData.filter(
      val => val.type != "vector"
    );
    selectedAllData = selectedData_screen.concat(selectedData);
    console.log(selectedAllData, '数据库选中')
    createCanvas("selected", "selected", "vector");
    reorderPickedLayer("selected");
    var canvas = document.getElementById("selected_changed");
    this.sellectedAllFilter(layerId, canvas);
  },
  /**
   * 不选中处理(切片数据)
   */
  async notSliceSelectedHandle(newData, layerId) {
    // console.log(newData)
    var selectedData = selectedAllData.filter(val => val.type === "screen");
    var index = selectedData.findIndex(
      val => val.Id === newData.Id && val.layerId === layerId
    );
    if (index > -1) {
      selectedData.splice(index, 1);
    } else {
      selectedData.push(newData);
    }

    var layerIndex = selectedIdData.findIndex(val => val.layerId === layerId);
    var idIndex = -1;
    if (layerIndex > -1) {
      var ids = selectedIdData[layerIndex].ids;
      idIndex = ids.findIndex(val => val === newData.Id);
      if (idIndex > -1) {
        ids.splice(idIndex, 1);
      } else {
        ids.push(newData.Id);
      }
    } else {
      selectedIdData.push({
        layerId: layerId,
        ids: [newData.Id]
      });
    }
    var selectedData_screen = selectedAllData.filter(
      val => val.type != "screen"
    );
    selectedAllData = selectedData_screen.concat(selectedData);
    console.log(selectedAllData, '切片选中')
    await createCanvas("selected", "selected", "screen");
    await reorderPickedLayer("selected");
    var canvas = document.getElementById("selected_changed");
    this.sellectedAllFilter(layerId, canvas);
  },

  /**
   * ctrl+点击不选中 (----)
   */
  clickNotSelectedHandle() {
    var data = lastPickedData[0];
    if (data.type === "vector") {
      //数据库数据
      this.notVectorSelectedHandle(data.data, data.layerId);
    } else {
      this.notSliceSelectedHandle(data, data.layerId);
    }
  },
  /**
   * 不选中数据过滤重绘
   * @param {*} canvas
   * @param {*} layerId
   */
  sellectedAllFilter(layerId, canvas) {
    // for (let i = 0; i < selectedAllData.length; i++) {
    //   const element = selectedAllData[i];
    //   if (element.type === "vector") {
    //     drawOnCanvasByChangeData(element.data, canvas, element.layerId);
    //   } else {
    //     redrawData(element.layerId, element.data, 'selected');
    //   }
    // }
    this.resetSelectedTileData(selectedIdData, layerId);
  },
  /**
   * 重置选择的canvas数据
   * @param {*} selectIDs 选中的ids
   */
  resetSelectedTileData(selectIDs, layerID) {
    if (TileData.length) {
      var selLayerIndex = selectIDs.findIndex(val => val.layerId === layerID);
      if (selLayerIndex > -1) {
        var layerId = selectIDs[selLayerIndex].layerId;
        var idss = selectIDs[selLayerIndex].ids;
        for (let j = 0; j < TileData.length; j++) {
          var val = TileData[j];
          if (val.layerId === layerId) {
            if (val.data) {
              for (let k = 0; k < idss.length; k++) {
                var idVal = idss[k];
                for (let f = 0; f < val.data.J.length; f++) {
                  var jVal = val.data.J[f];
                  if (idVal === jVal.O) {
                    redrawSelectedCanvas(
                      "screen",
                      jVal,
                      layerId,
                      val.row,
                      val.col,
                      val.geoType
                    );
                  }
                }
              }
            }
          }
        }
      }
    }


    if (AllChangedData.length) {
      var selLayerIndex = selectIDs.findIndex(val => val.layerId === layerID);
      if (selLayerIndex > -1) {
        var layerId = selectIDs[selLayerIndex].layerId;
        var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
        var idss = selectIDs[selLayerIndex].ids;
        for (let index = 0; index < idss.length; index++) {
          var element = idss[index];
          var layerIndex = AllChangedData.findIndex(
            val => val.layerId === layerId
          );
          if (layerIndex > -1) {
            var data = AllChangedData[layerIndex].data.find(
              val => val.Attr.ID === element && val.IsInView == true
            );
            if (data) {
              // console.log(data);
              redrawSelectedCanvas(
                "vector",
                data,
                layerId,
                0,
                0,
                layerInfo.GeoType
              );
            }
          }
        }
      }
    }
  },
  /**
   * 众包，数据.添加图层
   * @param {*} GDataId
   * @param {*} type 数据类型 如：data,map,zhongbao
   */
  addDataLayer(GDataId, type) {
    debugger
    var pageType = getPageType();
    let params = {
      UserId: store.state.user.UserId,
      GDataid: GDataId,
      type: pageType == 1 ? 1 : 0,
      mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1
    };
     
    getDataDetail_GDB(params).then(res => {
      if (res.data.state.Status == 1) {
        var data = res.data.Gdata_data;
        var renderType = "SimpleRender";
        var layerName = data.Name;
        var layerBigType = "矢量";
        var allLayers = store.state.allLayerData;
        var Id = 1;
        if (allLayers.length > 0) {
          Id = Math.max.apply(
            Math,
            allLayers.map(item => {
              return item.Id;
            })
          );
        }
        var layerSmallType =
          data.GDataType == 1 ? "点" : data.GDataType == 2 ? "线" : "面";
        //取symbol
        let layerSym = data.Symbol;
        let symbol = "";
        if (layerSym == "") {
          symbol = JSON.stringify({
            SymbolType: "Simple",
            Symbol: getDefaultSymbol(layerSmallType)
          });
        } else {
          symbol = layerSym;
          if (layerSym.indexOf("FieldName") > -1) {
            let sys = JSON.parse(layerSym);
            if (sys.RenderType == "ClassBreakRender") {
              renderType = "ClassBreakRender";
            } else {
              renderType = "UniqueRender";
            }
          }
          var LayerStr = {
            Id: Id + 1,
            LayerName: layerName,
            LayerType: layerBigType,
            GeoType: layerSmallType,
            LayerUrl: "",
            LayerField: "[]",
            Label: "",
            HeatMap: "",
            LayerAliasName: layerName,
            RenderType: renderType,
            LayerIndex: 0,
            Symbol: symbol,
            Opacity: 100,
            OpenState: 0,
            MaxScale: 0,
            MinScale: 0,
            IsChoice: 1,
            Isedit: 1,
            IsPicked: data.IsPickup ? 1 : 0,
            GDataId: data.Id,
            ParentId: 0,
            TaskDataId: data.TaskDataId,
            Executor: store.state.user.UserId,
            IsRelease: data.IsRelease,
            IsInDatabase: data.IsInDatabase,
            IsConcealed: 0,
            field: data.field,
            coordinate: parseInt(data.Coordinate),
            minScale: data.Minscale,
            levelRange: data.Classification,
            Extent: data.Extent,
            IsTileMode: data.IsTileMode
          };

          store.commit("changeDataLoadState", true);
          if (type === "data" || type === "zhongbao") {
            this.handleSaveLayer(data, LayerStr);
          } else {
            if (this.currentPageData.MapDocs.Userid != store.state.user.UserId) {
              this.handleSaveLayer(data, LayerStr);
            } else {
              this.addLayerByDoc(data, LayerStr);
            }
          }
        }
      }
    });
  },
  // 对数据进行保存
  handleSaveLayer(data, LayerStr) {
    var allLayers = store.state.allLayerData;
    var sortData = sortLayerIndex(allLayers, "矢量");
    sortData.unshift(LayerStr);
    store.commit("setAllLayerData", sortData);
    var node = getLegend(
      LayerStr.GeoType,
      LayerStr.RenderType,
      JSON.parse(LayerStr.Symbol),
      1
    );
    var pNode = {
      id: LayerStr.Id,
      label: LayerStr.LayerName,
      layerUnitCode: LayerStr.LayerName,
      labelField: "",
      labelChecked: "",
      heatMapChecked: "",
      heatMapField: "",
      renderField: "",
      type: "shapefileLayer",
      geoType: LayerStr.GeoType,
      targetType: "dataLayer",
      gDataId: data.Id,
      taskDataId: data.TaskDataId,
      checked: true,
      expanded: false,
      isEdit: LayerStr.Isedit,
      isSelected: LayerStr.IsChoice,
      IsPicked: LayerStr.IsPicked,
      isConcealed: 0,
      dataLoaded: true,
      parentId: 0,
      children: node
    };
    var tree = store.state.dataTreeData
    if (tree[0].children.length > 0) {
      tree[0].children.unshift(pNode);
    } else {
      tree[0].children.push(pNode);
    }
    store.dispatch("setDataTree", tree);
    //编辑工具条图层填充
    var layerOptions = store.state.editLayerOptions;
    var geoType =
      data.GDataType == 1 ?
      "point" :
      data.GDataType == 2 ?
      "polyline" :
      "polygon";
    var option = {
      label: LayerStr.LayerName,
      value: LayerStr.Id,
      type: "shapefile",
      taskDataId: data.TaskDataId,
      labelField: data.field,
      GDataId: LayerStr.GDataId,
      Id: LayerStr.Id,
      GDataType: geoType,
      isInDatabase: data.IsInDatabase,
      taskId: ""
    };
    if (layerOptions.length > 0) {
      layerOptions.unshift(option);
    } else {
      if (!data.IsRelease) {
        layerOptions.push(option);
      }
    }
    var coordinate = data.Coordinate;
    store.commit("setEditLayerOption", layerOptions);
    //地图上添加相应图层
    loadDragData(LayerStr.Id);
  },
  //保存到数据库
  addLayerByDoc(data, LayerStr) {
    let params = {
      LayerName: LayerStr.LayerName,
      LayerType: LayerStr.LayerType,
      GeoType: LayerStr.GeoType,
      LayerUrl: "",
      LayerAliasName: LayerStr.LayerName,
      RenderType: LayerStr.RenderType,
      Symbol: LayerStr.Symbol,
      Executor: store.state.user.UserId,
      MapDocUnitCode: store.state.SingleData.MapDocs.UnitCode,
      GDataId: LayerStr.GDataId,
      Isedit: LayerStr.Isedit,
      IsChoice: LayerStr.IsChoice,
      IsPicked: LayerStr.IsPicked
    };
    addLayer(params).then(res => {
      if (res.data.Status == 1) {
        this.$message({
          message: "添加成功！",
          type: "success"
        });
        LayerStr.Id = res.data.Data;
        this.upDateLayerPickedUp(data, LayerStr);
      } else {
        this.$message({
          message: res.data.Msg,
          type: "error"
        });
      }
    });
  },
  // 获取图片路径
  getImgPathUrl() {
    var baseURL = "";
    var hosts = myConfig.baseUrl.split(":");
    if (process.env.NODE_ENV === "development") {
      baseURL = myConfig.testUrl;
    } else {
      if (myConfig.baseUrl.indexOf("gispai") == -1) {
        var hosts = myConfig.baseUrl.split(":")
        baseURL = "http://" + hosts[0] + ":" + myConfig.serverPort
      } else {
        baseURL = myConfig.baseUrl + "/file"
      }
      // baseURL1 = "http://" + hosts[0] + ":" + myConfig.serverPort;
    }
    return baseURL;
  },
  /**深度拷贝 */
  deepClone(o) {
    if (!o) {
      return ""
    }
    if (
      typeof o === "string" ||
      typeof o === "number" ||
      typeof o === "boolean" ||
      typeof o === "undefined"
    ) {
      return o;
    } else if (Array.isArray(o)) {
      var _arr = [];
      o.forEach(item => {
        _arr.push(item);
      });
      return _arr;
    } else if (typeof o === "object") {
      var _o = {};
      for (let key in o) {
        _o[key] = this.deepClone(o[key]);
      }
      return _o;
    }
  },

  /**start 无极放大功能*********************************************************
   * 当地图放大超过设置的最大切片级别，使用最大切片级别的切片显示更大级别下的底图
   * @param {*} name
   * @param {*} MinX
   * @param {*} MinY
   * @param {*} MaxX
   * @param {*} MaxY
   * @param {*} CurrentLevel 当前的地图等级
   * @param {*} MaxTileLevel 最大地图图片可见等级
   * @param {*} MaxTileRes 最大分辨率
   * @param {*} TileOriginX 原点X
   * @param {*} TileOriginY
   */
  async addBaseLayerToCanvas(type) {
    var CurrentLevel = map.getLevel();
    var baseLayers = store.state.baseTreeData[0].children;
    // 最大显示级别
    var MaxTileLevel = 0;
    for (let index = 0; index < baseLayers.length; index++) {
      const layInfo = baseLayers[index];
      // 如未设置TitleMaxLevel 最大底图显示级别，无极放大功能无效
      MaxTileLevel = layInfo.TitleMaxLevel ? layInfo.TitleMaxLevel : 0
      if (layInfo.type === "baseLayerId") {
        MaxTileLevel = ZHT_baselayerInfo.TitleMaxLevel;
      }
      if (!layInfo.checked) {
        continue;
      }
      if (!MaxTileLevel || CurrentLevel <= MaxTileLevel) {
        var ele = document.querySelector(".baseLayer_" + layInfo.id);
        if (ele) {
          ele.remove()
        }
        continue
      }
      await this.createBaseLayer(MaxTileLevel, type, layInfo)
    }
    this.baseLayerSort(baseLayers)
  },
  // 底图图层排序
  baseLayerSort(baseLayers) {
    baseLayers.forEach((val, index) => {
      var ele = document.querySelector(".baseLayer_" + val.id);
      if (ele) {
        ele.style.zIndex = baseLayers.length - index;
      }
    })
  },
  /**
   *设置创建的底图图层显隐
   * @param {*} MaxTileLevel
   * @param {*} type
   * @param {*} layInfo
   * @returns
   */
  setBaseLayerHiden() {
    var baseLayers = store.state.baseTreeData[0].children;
    baseLayers.forEach((val, index) => {
      var ele = document.querySelector(".baseLayer_" + val.id);
      if (!val.checked) {
        if (ele) {
          ele.style.display = "none";
        }
      } else {
        if (ele) {
          ele.style.display = "block";
        }
      }
    })
  },
  /**
   * 创建底图canvas
   * @param {*} MaxTileLevel
   * @param {*} type
   * @param {*} layInfo
   * @returns
   */
  async createBaseLayer(MaxTileLevel, type, layInfo) {
    var layerId = layInfo.id;
    var esriModule = store.state.esriModule
    if (type === "extent") {
      ZHT_noDrawBaseData = [];
      var ele = document.querySelector(".baseLayer_" + layerId);
      if (ele) {
        ele.remove()
      }
    }
    //遍历minCol，maxCol，minRow，maxRow创建canvas并偏移，并且获取最大切片级别下的切片绘制到canvas上
    var div = document.querySelector("#mapView_gc");
    if (div == null) return;
    var layerdiv = document.querySelector(".baseLayer_" + layerId);
    if (!layerdiv) {
      layerdiv = document.createElement("div");
      layerdiv.className = "baseLayer_" + layerId
      layerdiv.style.position = "absolute";
      div.before(layerdiv);
    }
    var rowCol = await this.getBaseRowCol(MaxTileLevel, map.extent)
    var drawData = await this.removeExtentCanvas(rowCol, MaxTileLevel, map.extent, layerId)

    for (var k = 0; k < drawData.length; k++) {
      if (store.state.baseLayerDraging) {
        return
      }
      var i = drawData[k].row
      var j = drawData[k].col
      var ele = document.getElementById(layerId + "_" + i + "_" + j);
      if (!ele) {
        var path5 = this.getBasePath(layInfo, MaxTileLevel, i, j)
        ele = document.createElement("canvas");
        ele.className = "baseLayer";
        ele.style.left = rowCol.canvasSize * (j - rowCol.minCol) - rowCol.CanVasDx + "px";
        ele.style.top = rowCol.canvasSize * (i - rowCol.minRow) - rowCol.CanVasDy + "px";
        ele.setAttribute("id", layerId + "_" + i + "_" + j);
        ele.width = rowCol.canvasSize;
        ele.height = rowCol.canvasSize;
        ele.style.position = "absolute";
        await loadCompleted(path5).then(img => {
          var ctx = ele.getContext("2d");
          ctx.drawImage(img, 0, 0, rowCol.canvasSize, rowCol.canvasSize);
        });
        layerdiv.append(ele);
      }
      if (k === drawData.length - 1) {
        var rowCol2 = await this.getBaseRowCol(MaxTileLevel, map.extent)
        this.removeExtentCanvas(rowCol2, MaxTileLevel, map.extent, layerId)
      }
    }
  },
  /**
   * 获取底图路径
   * @param {*} MaxTileLevel 地图等级
   * @param {*} i 行
   * @param {*} j 列
   * @returns
   */
  getBasePath(layInfo, MaxTileLevel, i, j) {
    var path5 = ""
    if (layInfo.id === "bId") {
      path5 = this.urlhandle(ZHT_baselayerInfo, MaxTileLevel, i, j)
    } else {
      var ImgDataMap = "";
      if (layInfo.geoType == "GSPTile") {
        ImgDataMap = createGSPTile(layInfo.LayerUrl);
      } else if (layInfo.geoType == "ArcGISDynamic") {
        ImgDataMap = new esriModule.ArcGISDynamicMapServiceLayer(
          layInfo.LayerUrl
        );
      } else {
        ImgDataMap = new esriModule.ArcGISTiledMapServiceLayer(
          layInfo.LayerUrl
        );
      }

      path5 = this.urlhandle(ImgDataMap, MaxTileLevel, i, j)
    }
    return path5
  },
  // 路径处理
  urlhandle(baseMapInfo, MaxTileLevel, i, j) {
    if (baseMapInfo.thirdurl == "") {
      let timestamp = Date.now();
      let params =
        "c=" +
        j +
        "&dir=" +
        baseMapInfo.mapName +
        "&path=" +
        baseMapInfo.servicePath +
        "&r=" +
        i +
        "&tiletype=" +
        baseMapInfo.layerInfo.TileType +
        "&timestamp=" +
        timestamp +
        "&z=" +
        MaxTileLevel +
        "";
      let secretkey = md5(params + "12345678");
      var path = baseMapInfo.tileServers[0] + "MapServer/tile.ashx?c=" + j + "&dir=" + baseMapInfo.mapName + "&path=" + baseMapInfo.servicePath + "&r=" + i + "&tiletype=3&timestamp=" + timestamp + "&z=" + MaxTileLevel + "&secretkey=" + secretkey
      return path
    } else {
      var path1 = baseMapInfo.thirdurl.replace("${domains}", baseMapInfo.tileServers.split(",")[0])
      var path2 = path1.replace("{level}", MaxTileLevel)
      var path3 = path2.replace("{row}", i)
      var path4 = path3.replace("{col}", j)
      var path5 = path4.replace("{token}", baseMapInfo.DefaultToken)
      return path5
    }
  },
  /**
   *计算底图行列
   * @param {*} MaxTileLevel
   * @param {*} extent
   */
  getBaseRowCol(MaxTileLevel, extent) {
    var MinX = extent.xmin,
      MaxX = extent.xmax,
      MinY = extent.ymin,
      MaxY = extent.ymax;
    var lodVal = map.__tileInfo.lods[MaxTileLevel];
    var MaxTileRes = lodVal.resolution;
    var TileOriginX = map.__tileInfo.origin.x;
    var TileOriginY = map.__tileInfo.origin.y;

    //计算当前地图范围在最大切片级别下的最大最小行列
    var minCol = Math.floor((MinX - TileOriginX) / (256 * MaxTileRes));
    var maxCol = Math.floor((MaxX - TileOriginX) / (256 * MaxTileRes));
    var minRow = Math.floor((TileOriginY - MaxY) / (256 * MaxTileRes));
    var maxRow = Math.floor((TileOriginY - MinY) / (256 * MaxTileRes));

    //计算最小行的最小X和最大Y,以计算canvas偏移量(偏移左上角位置的x,y像素大小)
    var canvasSize = 256 * Math.pow(2, map.getLevel() - MaxTileLevel);
    var CanVasDx = ((MinX - minCol * 256 * MaxTileRes - TileOriginX) / (256 * MaxTileRes)) * canvasSize;
    var CanVasDy = ((TileOriginY - minRow * 256 * MaxTileRes - MaxY) / (256 * MaxTileRes)) * canvasSize;

    return {
      minCol: minCol,
      maxCol: maxCol,
      minRow: minRow,
      maxRow: maxRow,
      CanVasDx: CanVasDx,
      CanVasDy: CanVasDy,
      canvasSize: canvasSize,
    }
  },
  /**
   * 移除不在范围内的数据
   * @param {*} rowcol
   * @returns
   */
  removeExtentCanvas(rowcol, MaxTileLevel, extent, layerId) {
    var ctnelement = document.getElementsByClassName("baseLayer");
    if (ctnelement && ctnelement.length > 0) {
      var ele = ctnelement;
      for (var k = 0; k < ele.length; k++) {
        var ids = ele[k].id.split("_");
        var baseLayerId = ids[0] === "bId" ? ids[0] : +ids[0];
        var eRow = +ids[1];
        var eCol = +ids[2];
        //不在当前范围的行列移除
        if (baseLayerId === layerId) {
          if (
            eRow < rowcol.minRow ||
            eRow > rowcol.maxRow ||
            eCol < rowcol.minCol ||
            eCol > rowcol.maxCol
          ) {
            // console.log("移除", ele[k])
            ele[k].remove();
            k = k - 1;
          } else if (
            eRow >= rowcol.minRow &&
            eRow <= rowcol.maxRow &&
            eCol >= rowcol.minCol &&
            eCol <= rowcol.maxCol
          ) {
            //在当前范围行列
            //在当前范围的行列且不在未绘制的数据内
            var index = ZHT_noDrawBaseData.findIndex(val => {
              return (
                val.layerId === layerId && val.row === eRow && val.col === eCol
              );
            });
            if (index == -1) {
              ZHT_noDrawBaseData.push({
                layerId: layerId,
                row: eRow,
                col: eCol
              });
            }
            //偏移
            ele[k].style.left = rowcol.canvasSize * (eCol - rowcol.minCol) - rowcol.CanVasDx + "px";
            ele[k].style.top = rowcol.canvasSize * (eRow - rowcol.minRow) - rowcol.CanVasDy + "px";
          }
        }

      }
    }
    var arr = [];
    var baseRowCol = this.getBaseRowCol(MaxTileLevel, ZHT_lastExtent)
    for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
      for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
        if (
          i < baseRowCol.minRow ||
          i > baseRowCol.maxRow ||
          j < baseRowCol.minCol ||
          j > baseRowCol.maxCol
        ) {
          arr.push({
            row: i,
            col: j
          });
        } else if (
          i >= baseRowCol.minRow &&
          i <= baseRowCol.maxRow &&
          j >= baseRowCol.minCol &&
          j <= baseRowCol.maxCol
        ) {
          var newArr = ZHT_noDrawBaseData.filter(e => e.layerId === layerId);
          var index = newArr.findIndex(ele => {
            return ele.row == i && ele.col == j;
          });
          if (index == -1) {
            arr.push({
              row: i,
              col: j
            });
          }
        }
      }
    }
    arr = _.uniqWith(arr, _.isEqual); //去重
    ZHT_lastExtent = extent;
    return arr
  },
  /*************************************************************end */


  /**
   * 字符串点线面类别转整型
   * @param {*} str
   * @returns
   */
  toIntGeoType(str) {
    if (typeof str === "string") {
      if (str === "point") {
        return 1;
      } else if (str === "polyline") {
        return 2;
      } else if (str === "polygon") {
        return 3;
      }
    } else {
      return str
    }

  },
  // 判断是否是图片流
  isImageData(val) {
    if (val) {
      if (val.split("/")[1] === "Images") {
        return false
      } else {
        let arr = val.split(","),
          mime = arr[0].match(/:(.*?);/)[1];
        if (mime === "image/png") {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  },


  /**start 导出图片功能***********************************************
   * 导出大图范围数据
   */
  async exportImgExtent() {
    var geometry = tempGraphLayer.graphics[0].geometry
    ZHT_ExportImgDownLoadCount = 0;
    var vectorData = getVetorLayerNode(store.state.dataTreeData);
    var esriModule = store.state.esriModule;
    var extent = geometry.getExtent();
    var realCanvas = await this.creatExportCanvas(extent)
    // var rowcol = getRowCol(extent);
    var rowcol = this.exportGetRowCol(extent);
    // 1创建一个全屏的canvas 绘制范围内所有的数据
    // var div = document.querySelector("#mapView_gc");
    var tempCanvas = document.querySelector(".export_temp")
    if (tempCanvas) {
      tempCanvas.remove();
    }
    tempCanvas = document.createElement("canvas"); //缓存 canvas
    tempCanvas.className = "export_temp";
    tempCanvas.width = JSON.parse(JSON.stringify(realCanvas.clientWidth));
    tempCanvas.height = JSON.parse(JSON.stringify(realCanvas.clientHeight));

    //需要获取到最小的框选点,（反选的情况下）
    ZHT_ExportImgMinExtent = geometry.rings[0]

    ZHT_ExportImgTotal = 0;
    ZHT_ExportImgCount = 0;

    var exportPoint = new esriModule.Point(
      ZHT_ExportImgMinExtent[0][0],
      ZHT_ExportImgMinExtent[0][1],
      map.spatialReference
    );
    var screenExportPoint = map.toScreen(exportPoint);
    tempCanvas.style.left = screenExportPoint.x + "px";
    tempCanvas.style.top = screenExportPoint.y + "px";

    // tempCanvas.style.position = "absolute";
    // tempCanvas.style.background = "rgba(255,255,255,0.6)"
    // tempCanvas.style.zIndex = "21"
    // div.before(tempCanvas)

    for (var i = vectorData.length - 1; i >= 0; i--) {
      var vec = vectorData[i];
      var layerInfo = store.state.allLayerData.find(
        x => x.Id === vec.id
      );
      // 图层是否显示
      if (!isShowLayer(layerInfo.Id, layerInfo)) {
        continue;
      }

      //后台返回的数据库更改数据（ChangedData全局数据）
      var alldata = AllChangedData.find(e => e.layerId == vec.id);
      var viewdata = alldata.data.filter(ele => ele.IsInView == true)
      // var rowcol2 = getRowCol(map.extent);
      if (viewdata) {
        let drawData = [];
        for (let f = 0; f < viewdata.length; f++) {
          var ele = viewdata[f];
          var insGeo = getGeometry(ele.Shape, layerInfo.GeoType);
          let isIntersect = esriModule.geometryEngine.intersects(
            insGeo,
            geometry
          );
          //取相交
          if (isIntersect) {
            drawData.push(ele)
          }
        }
        if (drawData.length) {
          // 绘制数据库数据
          await drawData_Changed(vec.id, realCanvas, layerInfo, drawData, tempCanvas, "export", geometry.rings[0])
        }
      }

      // 切片数据遍历行列
      var param = isAddToParams(layerInfo.Id);
      for (var j = rowcol.minRow; j <= rowcol.maxRow; j++) {
        for (var k = rowcol.minCol; k <= rowcol.maxCol; k++) {
          ZHT_ExportImgTotal++;
          var pageType = getPageType();
          var basemapID = -1;
          if (pageType == 0) {
            // store.state.SingleData.BMPID  在线影像的时候用这个
            basemapID = store.state.SingleData.Gdata_data ? store.state.SingleData.Gdata_data.BMPId : store.state.SingleData.BMPID;
          } else {
            basemapID = store.state.SingleData.BMPId;
          }
          var params = {
            UserId: store.state.user.userid,
            GDataId: layerInfo.GDataId,
            Coordinate: layerInfo.coordinate,
            Level: map.getLevel(),
            Row: j,
            Column: k,
            type: pageType == 1 ? 1 : 0,
            mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
            tiletype: 'v',
            BMPId: basemapID
          };
          params = Object.assign(params, param);
          await getGDataObject(params).then(async res => {
            if (res.data.T != 0 && res.data) {
              if (layerInfo.GeoType === "面") {
                // 创建一块256 canvas 面需要另外处理
                var canvas = this.creatVectorExportTempCanvas(j, k, extent, layerInfo.Id);
                await drawOnCanvas(layerInfo.Id, j, k, canvas, layerInfo, res.data, "real", "drag");
                var ctx = realCanvas.getContext("2d");
                // 复选框的偏移量
                var offset = this.exportExentToScreen(layerInfo);
                var x = parseInt(canvas.style.left.split("px")[0]) - offset.x;
                var y = parseInt(canvas.style.top.split("px")[0]) - offset.y;
                ctx.drawImage(canvas, x, y);
              } else {
                await drawOnCanvas(layerInfo.Id, j, k, realCanvas, layerInfo, res.data, "real", "drag", "", "export");
              }
            }
          })
        }
      }
    }

    setTimeout(() => {
      this.exportImage(realCanvas)
    }, 1000);
    // 导出图片
    // this.exportImage(realCanvas)

  },
  /**
   * 导出图片行列
   * extent 范围
   */
  exportGetRowCol(extent) {
    var level = map.getLevel();
    var OriginX = -20037508.342787;
    var OriginY = -20037508.342787;
    if (
      extent.ymax <= 200 &&
      extent.xmax <= 360 &&
      extent.ymax >= -200 &&
      extent.xmax >= -360
    ) {
      OriginX = -180;
      OriginY = -90;
    }

    var res = map.__tileInfo.lods[level].resolution;
    var minrow = Math.floor((extent.ymin - OriginY) / (res * 256));
    var maxrow = Math.floor((extent.ymax - OriginY) / (res * 256));
    var mincol = Math.floor((extent.xmin - OriginX) / (res * 256));
    var maxcol = Math.floor((extent.xmax - OriginX) / (res * 256));

    return {
      minRow: minrow,
      maxRow: maxrow,
      minCol: mincol,
      maxCol: maxcol
    };
  },
  /**
   * 导出大图选择范围转屏幕坐标
   * @param {*} layerInfo
   * @returns
   */
  exportExentToScreen(layerInfo, esriModule) {
    var _esriModule = esriModule;
    if (!_esriModule) {
      _esriModule = store.state.esriModule;
    }
    var spatialReference = "";
    // if (layerInfo) {
    // spatialReference = new _esriModule.SpatialReference(layerInfo.coordinate)
    // } else {
    spatialReference = map.spatialReference
    // }
    var orpt = new _esriModule.Point(
      ZHT_ExportImgMinExtent[0][0],
      ZHT_ExportImgMinExtent[0][1],
      spatialReference
    )
    var pts = convertLngLat(layerInfo.coordinate, orpt)
    var pt = map.toScreen(pts);
    return pt;
  },
  /**
   * @description: 导出大图计算某行某列偏移量
   * @export
   * @param {*} row 行号
   * @param {*} col 列号
   * @return {*}
   */
  getExportCoordByRowCol(row, col, extent) {
    var esriModule = store.state.esriModule;
    var level = map.getLevel();
    // 原点
    var OriginX = -20037508.342787;
    var OriginY = -20037508.342787;

    if (
      extent.ymax <= 200 &&
      extent.xmax <= 360 &&
      extent.ymax >= -200 &&
      extent.xmax >= -360
    ) {
      OriginX = -180;
      OriginY = -90;
    }
    // 地图分辨率
    var res = map.__tileInfo.lods[level].resolution;
    // 计算出当前分辨率行列的起始点
    var x = col * res * 256 + OriginX;
    var y = (row + 1) * res * 256 + OriginY;

    //像素偏移量的xy
    var offsetX = (extent.xmin - x) / res;
    var offsetY = (extent.ymin - y) / res;

    var point = new esriModule.Point(
      extent.xmin,
      extent.ymin,
      map.spatialReference
    );
    var screenPoint = map.toScreen(point);
    // 像素偏移量
    return {
      offsetX: screenPoint.x - offsetX,
      offsetY: screenPoint.y + offsetY
    };
  },
  /**
   * 创建导出大图临时的canvas
   * @param {*} row
   * @param {*} col
   * @returns
   */
  creatVectorExportTempCanvas(row, col, extent, layerId) {
    var pdiv = document.querySelector("#mapView_gc");
    var offset = this.getExportCoordByRowCol(row, col, extent);
    var canvas = document.createElement("canvas");
    canvas.className = "gispaiLayer_export";

    canvas.style.left = offset.offsetX + "px";
    canvas.style.top = offset.offsetY + "px";
    canvas.setAttribute("id", layerId + "_" + row + "_" + col + "_" + "export");
    canvas.width = 256;
    canvas.height = 256;
    canvas.style.width = 256 + "px";
    canvas.style.height = 256 + "px";
    canvas.style.position = 'absolute';
    canvas.style.zIndex = -2;
    // canvas.style.background = 'rgba(255,255,255,0.6)';
    pdiv.before(canvas)
    return canvas
  },
  /**
   *创建导出canvas
   * @param {*} extent canvas范围
   * @return {*}
   */
  async creatExportCanvas(extent) {
    var div = document.querySelector("#mapView_gc");
    if (div == null) return;
    var canvasCtn = document.querySelector(".export")
    if (canvasCtn) {
      canvasCtn.remove()
    }
    canvasCtn = document.createElement("canvas");
    canvasCtn.setAttribute("id", "export")
    var level = map.getLevel();
    var res = map.__tileInfo.lods[level].resolution
    var minrow = Math.floor((extent.ymin) / (res))
    var maxrow = Math.floor((extent.ymax) / (res))
    var mincol = Math.floor((extent.xmin) / (res))
    var maxcol = Math.floor((extent.xmax) / (res))
    // canvasCtn.style.background = "rgba(255,255,255,0.6)"
    canvasCtn.style.zIndex = -3;
    canvasCtn.style.position = "absolute"
    canvasCtn.className = "export"
    canvasCtn.style.width = maxcol - mincol + "px"
    canvasCtn.style.height = maxrow - minrow + "px"
    canvasCtn.width = maxcol - mincol
    canvasCtn.height = maxrow - minrow
    div.before(canvasCtn);
    await this.drawExportBaseMap(canvasCtn, extent);
    return canvasCtn
  },
  /**
   * 给导出图片的canvas绘制底图
   * @param {*} canvas
   */
  async drawExportBaseMap(realCanvas, extent) {
    var baseRowcol = this.getBaseRowCol(map.getLevel(), extent)
    var baseLayers = store.state.baseTreeData[0].children;
    var baseLayerIndex = 0;
    for (let index = 0; index < baseLayers.length; index++) {
      var layerInfo = baseLayers[index];
      if (layerInfo.checked) {
        baseLayerIndex = index;
        break
      }
    }
    var layer = baseLayers[baseLayerIndex];
    var realctx = realCanvas.getContext("2d");

    for (var j = baseRowcol.minCol; j <= baseRowcol.maxCol; j++) {
      for (var k = baseRowcol.minRow; k <= baseRowcol.maxRow; k++) {
        var ele = document.createElement("canvas");
        var offsetX = baseRowcol.canvasSize * (j - baseRowcol.minCol) - baseRowcol.CanVasDx;
        var offsetY = baseRowcol.canvasSize * (k - baseRowcol.minRow) - baseRowcol.CanVasDy
        ele.style.left = `${offsetX}px`;
        ele.style.top = `${offsetY}px`;
        ele.width = baseRowcol.canvasSize;
        ele.height = baseRowcol.canvasSize;
        ele.style.position = "absolute";
        var path5 = this.getBasePath(layer, map.getLevel(), k, j)
        // 转化为base64
        var base64 = await this.getBase64(path5)
        await loadCompleted(base64).then(img => {
          var ctx = ele.getContext("2d");
          ctx.drawImage(img, 0, 0, baseRowcol.canvasSize, baseRowcol.canvasSize);
        });
        realctx.drawImage(ele, offsetX, offsetY)
      }
    }
  },
  //下载图片
  async exportImage(canvas) {
    //保证一次点击只能下载一次
    ZHT_ExportImgDownLoadCount++;
    if (ZHT_ExportImgDownLoadCount >= 2) {
      return;
    }
    var fileName = Number(new Date()) + '.jpg';
    //判断是否是IE
    if (window.navigator.msSaveBlob) {
      //支持IE10，IE11 ,Edage
      var blob = canvas.msToBlob();
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      var alink = document.createElement("a");
      // 1 toDataURL直接下载 ,生成的base64的字符太大, 导致无法解析
      // alink.href = canvas.toDataURL('image/png');;
      // alink.download = fileName;
      // alink.click();

      // 2转换为Blob进行下载
      var blob = canvas.toBlob(blob => {
        var url = URL.createObjectURL(blob);
        // 3 上传到服务器返回url
        // var url = this.imgUploadToSever(blob)
        alink.href = url;
        alink.download = fileName;
        alink.click();
      });

      // 4 使用html2canvas 下载
      // await this.html2canvasDownLoadImage(canvas)
    }

    var canvasElements = document.getElementsByClassName("gispaiLayer_export")
    var exportCanvasElements = document.getElementsByClassName("export")
    //移除临时的绘制的cnavas
    this.removeExportCanvas(canvasElements)
    //移除绘制的全屏canvas
    this.removeExportCanvas(exportCanvasElements)

  },
  /**
   *  html2canvas 下载图片
   * @param {*} canvas 需要截屏的canvas
   */
  async html2canvasDownLoadImage(canvas) {
    var fileName = Number(new Date()) + '.jpg';
    var canvasTemp = document.createElement('canvas');
    // canvasTemp.style.zIndex = 21;
    canvasTemp.width = canvas.width
    canvasTemp.height = canvas.height
    var opts = {
      // scale: 1,
      canvas: canvasTemp,
      // width: parseInt(canvas.style.width.split('px')[0]),
      // height: parseInt(canvas.style.height.split('px')[0]),
      // dpi: window.devicePixelRatio,
      useCORS: true,
      allowTaint: false,
    };
    // var div = document.querySelector("#mapView_gc");
    html2canvas(canvas, opts).then(_canvas => {
      var alink = document.createElement("a");
      alink.href = _canvas.toDataURL('image/png');
      alink.download = fileName;
      alink.click();
    });
  },
  /**
   * 通过calssName 移除canvas
   * @param {*} elements
   */
  removeExportCanvas(elements) {
    if (elements && elements.length) {
      for (let index = 0; index < elements.length; index++) {
        var data = elements[index];
        // canvasElements.splice(index,1)
        data.remove();
        index--;
      }
    }
  },
  /**
   * 获取切片数据的Geometry
   * @param {*} data 图形数据
   * @param {*} layerInfo
   * @returns
   */
  getGeometry(data, layerInfo) {
    var symbol = JSON.parse(layerInfo.Symbol);
    let ngeo;
    //点线面转为屏幕坐标的geometry
    if (layerInfo.GeoType == "点") {
      //转屏幕坐标
      ngeo = getGeometryToScreen(
        data.G,
        layerInfo.GeoType,
        symbol
      );
    } else if (layerInfo.GeoType == "线") {
      var jitem = [];
      data.G.forEach(gitem => {
        let tempitem = gitem.filter(x => x != null);
        if (tempitem.length >= 2) {
          jitem.push(tempitem);
        }
      });
      if (jitem.length > 0) {
        ngeo = getGeometryToScreen(jitem, layerInfo.GeoType);
      }
    } else {
      var jitem = [];
      for (let k = 0; k < data.G.length; k++) {
        var gitem = data.G[k];
        let tempitem = gitem.filter(x => x != null);
        // if (tempitem.length >= 4) {
        jitem.push(tempitem);
        // }
      }
      ngeo = getGeometryToScreen(jitem, layerInfo.GeoType);
    }
    return ngeo
  },
  /**
   * 网络图片转base64
   * @param {*} imgUrl
   * @returns
   */
  getBase64(imgUrl) {
    return new Promise((resolve, reject) => {
      window.URL = window.URL || window.webkitURL;
      var xhr = new XMLHttpRequest();
      xhr.open("get", imgUrl, true);
      // 重要
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (this.status == 200) {
          //得到一个blob对象
          var blob = this.response;
          let oFileReader = new FileReader();
          oFileReader.onloadend = function (e) {
            // 此处拿到的已经是 base64的图片了
            let base64 = e.target.result;
            resolve(base64)
          };
          oFileReader.readAsDataURL(blob);
        }
      }
      xhr.send();
    })

  },
  /**
   * 将blob转换为file
   * @param {*} theBlob  Blob 数据
   * @param {*} fileName
   * @returns
   */
  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  },
  /**
   *  blob图片上传到图片服务器
   * @param {*} theBlob Blob数据
   * @returns
   */
  imgUploadToSever(theBlob) {
    return new Promise((resolve, reject) => {
      var fileName = Number(new Date())
      var file = this.blobToFile(theBlob, fileName);
      let formData = new FormData();
      formData.append("files", file);
      UploadImage(formData).then(res => {
        if (res.data) {
          resolve(res.data);
        }
      });
    });
  },
  /*************************************************************end */


  /**
   * 对象数组去重
   * @param {*} obj 对象数组
   * @returns
   */
  deteleObject(obj) {
    var uniques = [];
    var stringify = {};
    for (var i = 0; i < obj.length; i++) {
      var keys = Object.keys(obj[i]);
      keys.sort(function (a, b) {
        return (Number(a) - Number(b));
      });
      var str = '';
      for (var j = 0; j < keys.length; j++) {
        str += JSON.stringify(keys[j]);
        str += JSON.stringify(obj[i][keys[j]]);
      }
      if (!stringify.hasOwnProperty(str)) {
        uniques.push(obj[i]);
        stringify[str] = true;
      }
    }
    uniques = uniques;
    return uniques;
  },

};
